import { Component, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
declare var jquery: any;
declare var $: any;
import { ActivatedRoute, Router } from '@angular/router';
import { GridOptions } from "ag-grid/main";
import { ClientsService, RaterDto } from 'app/services/client/ClientsService';
import { Globals } from 'app/globals';
import { CoachService, CoachClientDto, ImportRatersDto } from 'app/services/coach/CoachService';
import { ToastrService } from 'ngx-toastr';
import { AssignAssesmentsNewModalComponent } from '../assign-assesments-new-modal/assign-assesments-new-modal.component';
import { RaterTypesForModalComponent } from '../c-rater-types/rater-types-for-modal/rater-types-for-modal.component';
import { RatersService } from 'app/services/rater/RatersService';
import { AdminService } from 'app/services/admin/AdminService';
import { RatersModalComponent } from '../raters-modal/raters-modal.component';
import { PurchaseAssessmentModalComponent } from '../../purchase-assessment-modal/purchase-assessment-modal.component';
import { AssignAssessmentModalComponent } from '../../assign-assessment-modal/assign-assessment-modal.component';
import { AssessmentsService } from '../../services/assessment/AssessmentsService';
import { CryptoJs } from '../../shared/crypto-js/crypto-js.component';


@Component({
  selector: 'app-edit-client',
    templateUrl: './edit-client.component.html',
    styleUrls: ['./edit-client.component.scss']
})
export class EditClientComponent implements OnInit {

    //@ViewChild('assignAssessmentNew') public assignAssessmentModal: AssignAssesmentsNewModalComponent;
    @ViewChild('raterTypesForModal', {static: true}) public raterTypesForModal: RaterTypesForModalComponent;
    @ViewChild('ratersModal', {static: true}) private ratersModal: RatersModalComponent;

    @ViewChild('purchaseAssessment', {static: true}) public purchaseAssessmentModal: PurchaseAssessmentModalComponent;
    @ViewChild('assignAssessment', {static: true}) public assignAssessmentModal: AssignAssessmentModalComponent;

    client = {
        id: 0,
        email: "",
        firstName: "",
        lastName: "",
        status:""
    };

    data: any[] = [];
    dataHeaders: any[] = [];
    gridOptions: GridOptions;
    raterGridOptions: GridOptions;
    gridApi;
    gridColumnApi;
    overlayNoRowsTemplate;
    height: number;
    count: number;
    rowCountData = [];
    currentSelectedTab: number = 1;
    loading: boolean = true;
    sendingEmail: boolean = false;
    pointerEvents: boolean = true;
    expiresOn = this.getTodayDate2();
    sentDate = this.getTodayDate2();
    importDate: Date = new Date();
    date1: Date = new Date();
    settings = {
        bigBanner: false,
        timePicker: false,
        format: 'MM-dd-yyyy',
        defaultOpen: false
    };
    inProgress: boolean = false;
    ratersHeaders: any[];
    raters: any[] = [];
    raterGridApi;

    canUpdate: boolean = false;
    canCopy: boolean = false;
    canDelete: boolean = false;
    canAddRaters: boolean = false;
    canAddTags: boolean = false;

    assignedCanSendReminder: boolean = false;

    assignedRegularData: any;
    assigned360Data: any;

    assignedCanSend: boolean = false;
    canDeleteRaters: boolean = false;

    clientId: number;
    fileName: string = "";
    blobFile: any = null;

    importRaterPageIdx: number = 0;

    hours: string[] = [
        "00:00 AM",
        "01:00 AM",
        "02:00 AM",
        "03:00 AM",
        "04:00 AM",
        "05:00 AM",
        "06:00 AM",
        "07:00 AM",
        "08:00 AM",
        "09:00 AM",
        "10:00 AM",
        "11:00 AM",
        "12:00 PM",
        "01:00 PM",
        "02:00 PM",
        "03:00 PM",
        "04:00 PM",
        "05:00 PM",
        "06:00 PM",
        "07:00 PM",
        "08:00 PM",
        "09:00 PM",
        "10:00 PM",
        "11:00 PM"
    ];
    assignmentId: number;

    /*new rater*/
    rater = {
        email: "",
        raterType: 0,
        firstName: "",
        lastName: ""
    }
    addRaterPageIdx: number = 0;
    languages: string[] = [];
    language: any;
    raterTypes: any[] = [];

    scheduledDate: string = "";
    expiresIn: any;
    selectedHour: string = "";
    scheduleSelected: string = "";
    selectedGtmValue: number;
    addingRater: boolean = false;
    raterOverlayNoRowaTemplate;
    completedCanEnableResults: boolean = false;
    actionForRater: string = 'Add';
    raterForEdit: any;
    addingNewRater: boolean = false;
    currentAction: string = 'add';
    rowIndex: any;
    addedRaters: any[] = [];
    editedRaters: any[] = [];
    deletedRaters: any[] = [];
    //selectedRatersForDelete: any[] = [];
    categoryMin: number;
    tempId = "tempId";
    counter = 0;
    relationshipId: any;
    lastCategory: string = 'categories';
    noRaters: boolean = false;
    raterToDelete: any;
    bulkDeleteCategoryId: any;
    lastRelationshipClicked: number;
    executed: boolean = false;
    pristineRaters: any[] = [];

    raterTypesStandartData: string[] = [];
    raterTypesCustomData: string[] = [];
    raterTypesStandartDataHeaders: any[];
    raterTypesCustomDataHeaders: any[];
    raterTypesStandartGridApi;
    raterTypesCustomGridApi;
    action: string;
    isStandard: boolean = false;
    name: string = '';
    currentRaterId: number;
    rtgridOptions: GridOptions;
    arrActiveCategories: any[] = [];
    pristineCategories: any[] = [];
    executet: boolean = false;
    modalIndex: number;
    displayRatersModal: boolean = false;
    className: string = 'EditClientComponent';
    pageName = "edit_clients";
    fromExpired: boolean = false;
    assessmentHour: string;
    archiving = false;
    completedCanArchiveAssessments = false;
    restoring = false;
    canRestoreAssessments = false;
    assessmentAddTags = [];
    addTags = [];
    coachTagsHeaders: any[];
    coachTags: any[] = [];
    coachTagsGridApi;
    selectedCoachTags: any[] = [];
    placeholder: string = "Enter tag";

    constructor(
        private _CoachService: CoachService,
        private _ClientsService: ClientsService,
        private activatedRoute: ActivatedRoute,
        private _AssessmentsService: AssessmentsService,
        public _Globals: Globals,
        private _toastr: ToastrService,
        private _RatersService: RatersService,
        private _AdminService: AdminService,
        private _router: Router,
        private _CryptoJs: CryptoJs
    ) {
        this.activatedRoute.params.subscribe(params => {
            console.log("PARAMS", params);

            this.client.id = params['clientId'];
            this.client.email = params['email'];
            this.client.firstName = params['name'];
            this.client.lastName = params['last'];
            this.client.status = params['status'];
            this.rowCountData = [{ ClientId: this.client.id }];
            //edit_clients/:clientId/:email/:name/:last/:status
            this._Globals.setRouterUrls('edit_clients', 'app/edit_clients/' + this.client.id + '/' + this.client.email + '/' + this.client.firstName + '/' + this.client.lastName + '/' + this.client.status + '');
        });

        this.overlayNoRowsTemplate = "<span>No row to show</span>";
        this.raterOverlayNoRowaTemplate = '<span>There are no raters assigned to this assessment</span>';
    }

    ngOnInit() {
        this.gridOptions = <GridOptions>{};
        this.gridOptions.rowHeight = 45;
        this.gridOptions.headerHeight = 40;

        this.raterGridOptions = <GridOptions>{};
        this.raterGridOptions.rowHeight = 45;
        this.raterGridOptions.headerHeight = 40;

        this.rtgridOptions = <GridOptions>{};
        this.rtgridOptions.rowHeight = 45;
        this.rtgridOptions.headerHeight = 40;


        this._Globals.assignedCanConversionRate = false;

        //this.dataHeaders = this.createAvailableHeaders();

        //service calls 
        //this.getCoachAvailableAssessmentsByType(1);
        this.dataHeaders = this.createAssignedHeaders();
        this.getClientAssignedAssessmentsByType(1);
        this.getLanguages();
        this.getRaterTypesForCoach(false);
        this.displayRatersModal = true;
    }

    ngOnDestroy() {
        //this.displayRatersModal = false;
        //this.viewContainerRef.clear();
    }

    public getTodayDate2() {
        var today: any = new Date();
        var dd: any = today.getDate();

        var mm: any = today.getMonth() + 1;
        var yyyy = today.getFullYear();
        if (dd < 10) {
            dd = '0' + dd;
        }

        if (mm < 10) {
            mm = '0' + mm;
        }
        today = yyyy + '-' + mm + '-' + dd;
/*        console.log(today);*/

        return today;
    }

    private getDate(date) {
        var dd: any = date.getDate();

        var mm: any = date.getMonth() + 1;
        var yyyy = date.getFullYear();
        if (dd < 10) {
            dd = '0' + dd;
        }

        if (mm < 10) {
            mm = '0' + mm;
        }
        date = yyyy + '-' + mm + '-' + dd;
        console.log(date);

        return date;
    }

    //SERVICES 
    getClientAssignedAssessmentsByType(assessmentType: number) {
        this._ClientsService.getClientAssignedAssessmentsByType(this.client.id, assessmentType).subscribe((data: any) => {
            console.log('response_', data);
            if (this._Globals.validationToken(data.result.Result)) {
                let _data = JSON.parse(data.result.Data);
                console.log('_data', _data);
                this.data = _data;
                this.loading = false;
                setTimeout(() => {
                    this.sizeToFit(this.gridApi);
                }, 100);
            }
        });
    }

    getClientCompletedAssessmentsByType(assessmentType: number) {
        this._ClientsService.getClientCompletedAssessmentsByType(this.client.id, assessmentType).subscribe((data: any) => {
            console.log('response_', data);
            if (this._Globals.validationToken(data.result.Result)) {
                let _data = JSON.parse(data.result.Data);
                console.log('_data', _data);
                this.data = _data;
                setTimeout(() => {
                    this.sizeToFit(this.gridApi);
                }, 10);
            }
        });
    }

    getClientArchivedAssessments(assessmentType: number) {
        this._ClientsService.getClientArchivedAssessments(this.client.id, assessmentType).subscribe((data: any) => {
            console.log('response_', data);
            if (this._Globals.validationToken(data.result.Result)) {
                let _data = JSON.parse(data.result.Data);
                console.log('_data', _data);
                this.data = _data;
                setTimeout(() => {
                    this.sizeToFit(this.gridApi);
                }, 10);
            }
        });
    }

    getClientExpiredAssessmentsByType(assessmentType: number) {
        this._ClientsService.getClientExpiredAssessmentsByType(this.client.id, assessmentType).subscribe((data: any) => {
            console.log('response_', data);
            if (this._Globals.validationToken(data.result.Result)) {
                let _data = JSON.parse(data.result.Data);
                console.log('_data', _data);
                this.data = _data;
                setTimeout(() => {
                    this.sizeToFit(this.gridApi);
                }, 10);
            }
        });
    }

    setAllInFalse() {
        this.assignedCanSendReminder = false;
        this.canUpdate = false;
        this.canCopy = false;
        this.canDelete = false
        this.canAddRaters = false
        this.canAddTags = false;
    }

    //METHODS
    tabSelect(event: any) {
        console.log('tabSelect');
        console.log(event);
        this.currentSelectedTab = event;
        this.deselectAllCheckBox(this.gridApi);

        switch (event) {

            //case 0: {
            //    $(".desktopTabs li").removeClass('active in');
            //    $(".desktopTabs li").eq(0).addClass('active in');
            //    $(".editClientTabs .tab-pane").removeClass('active in');
            //    $(".editClientTabs .tab-pane").eq(0).addClass('active in');
            //    $("#0").addClass('active in');
            //    this.dataHeaders = this.createAvailableHeaders();
            //    this.getCoachAvailableAssessmentsByType(1);
            //    break;
            //}

            //case 0.2: {
            //    this.dataHeaders = this.createAvailableHeaders();
            //    this.getCoachAvailableAssessmentsByType(2);
            //    break;
            //}

            case 1: {
                $(".nav-tabs li").removeClass('active in');
                $(".nav-tabs li").eq(0).addClass('active in');
                $(".editClientTabs .tab-pane").removeClass('active in');
                $(".editClientTabs .tab-pane").eq(0).addClass('active in');
                $("#1").addClass('active in');
                this.dataHeaders = this.createAssignedHeaders();
                this.getClientAssignedAssessmentsByType(1);
                break;
            }

            case 1.2: {
                this.dataHeaders = this.createAssignedHeaders360();
                this.getClientAssignedAssessmentsByType(2);
                break;
            }

            case 2: {
                this.completedCanEnableResults = false;
                this.completedCanArchiveAssessments = false;
                $(".nav-tabs li").removeClass('active in');
                $(".nav-tabs li").eq(1).addClass('active in');
                $(".editClientTabs .tab-pane").removeClass('active in'); 
                $(".editClientTabs .tab-pane").eq(1).addClass('active in');
                $("#2").addClass('active in');
                this.dataHeaders = this.createCompletedHeaders();
                this.getClientCompletedAssessmentsByType(1);
                break;
            }

            case 2.2: {
                this.dataHeaders = this.createCompletedHeaders();
                this.getClientCompletedAssessmentsByType(2);
                break;
            }

            case 3: {
                $(".nav-tabs li").removeClass('active in'); 
                $(".nav-tabs li").eq(2).addClass('active in');
                $(".editClientTabs .tab-pane").removeClass('active in'); 
                $(".editClientTabs .tab-pane").eq(2).addClass('active in');
                $("#3").addClass('active in');
                this.dataHeaders = this.createAssignedHeaders();
                this.getClientExpiredAssessmentsByType(1);
                break;
            }

            case 3.2: {
                this.getClientExpiredAssessmentsByType(2);
                break;
            }

            case 4: {
                $(".nav-tabs li").removeClass('active in');
                $(".nav-tabs li").eq(3).addClass('active in');
                $(".editClientTabs .tab-pane").removeClass('active in');
                $(".editClientTabs .tab-pane").eq(3).addClass('active in');
                $("#4").addClass('active in');
                this.dataHeaders = this.createCompletedHeaders();
                this.getClientArchivedAssessments(1);
                break;
            }

            case 4.2: {
                this.dataHeaders = this.createCompletedHeaders();
                this.getClientArchivedAssessments(2);
                break;
            }
        }

        //setTimeout(() => {
        //    $(".ag-floating-filter-input").attr("placeholder", "Filter");
        //    this.loading = false;
        //}, 500);

    }

    updateClient() {
        if (this.client.firstName == "" || this.client.lastName == "") {
            this._toastr.warning('Please complete all the fields.', "ELI");
            return;
        }

        var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
        let validEmail = regex.test(this.client.email);
        console.log('Valid', validEmail)
        if (validEmail) {
            $('body').css('cursor', 'wait');

            let coachClient = new CoachClientDto;
            coachClient.ClientId = this.client.id;
            coachClient.FirstName = this.client.firstName;
            coachClient.LastName = this.client.lastName;
            coachClient.Email = this.client.email;
            this.inProgress = true;

            this._CoachService.postUpdateClient(coachClient).subscribe(data => {
                console.log('response_postUpdateClient', data);
                $('body').css('cursor', 'default');
                this.hideEditClientModal();
                setTimeout(() => {
                    this.inProgress = false;
                }, 500);
                if (this._Globals.validationToken(data.result.Result)) {
                    if (data.result.Result === 1) {
                        this._toastr.success("Client updated successfully.", "ELI");
                        return;
                    }

                    if (data.result.Result === -1) {
                        this._toastr.error("Client info cannot be updated since the entered email address is currently in use by another user", "ELI");
                    } else {
                        this._toastr.error("An error happen, please try again.", "ELI");
                    }
                    
                }
            });
        } else {
            this._toastr.warning('Please enter a valid email address', "ELI");
        }
    }

    //openAssignAssessmentModal() {
    //    this.modalIndex = 1;
    //    let is360 = this.gridApi.getSelectedRows()[0].Is360;
    //    this.assignAssessmentModal.show(this, true, is360, undefined, "", undefined, this.client.id);
    //}

    onResize() {
        this.sizeToFit(this.gridApi);
    }

    /*Confirmation Delete*/
    openConfirmationModal() {
        $("#editClientConfirmationDeleteModal").modal({ backdrop: "static" });
        $('#editClientConfirmationDeleteModal').modal('show');
    }

    closeModalConfirmation() {
        $('#editClientConfirmationDeleteModal').modal('hide');
    }

    deleteClients() {
        this._CoachService.postDeleteClients([this.client.id]).subscribe((data: any) => {
            console.log('response_deleteClients', data);
            if (this._Globals.validationToken(data.result.Result)) {

                let _data = JSON.parse(data.result.Data);
                console.log('_data', _data);

                if (data.result.Result === 1) {
                    this._toastr.success('Clients deleted successfully.', 'ELI');
                    this._router.navigate(["/app/clients"]);
                } else {
                    this._toastr.warning("The client could not be removed because have pending assessments or is assigned as raters for other clients.", "ELI");
                    this.closeModalConfirmation();
                }

            }
        });
    }

    getCoachAvailableAssessmentsByType(assessmentType: number) {
        this._CoachService.getCoachAvailableAssessmentsByType(assessmentType).subscribe((data: any) => {
            if (this._Globals.validationToken(data.result.Result)) {
                let _data = JSON.parse(data.result.Data);
                console.log('response_GetCoachAvailableAssessmentsByType', _data);

                this.data = _data;
                this.loading = false;
                setTimeout(() => {
                    this.sizeToFit(this.gridApi);
                }, 100);

            }

        });
    }

    //AG-GRID
    gridSize(count: number) {
        this.count = count;
        console.log('count', this.count);
        this.height = (this.count + 1) * 43;
    }

    sizeToFit(gridApi) {
        gridApi.sizeColumnsToFit();
        $('.ag-body-viewport').css('overflow', 'overlay');
        setTimeout(() => {
            $(".ag-floating-filter-input").attr("placeholder", "Filter");
        }, 100);
    }

    onGridReady(params) {
        this.gridApi = params.api;
        this.sizeToFit(this.gridApi);
        setTimeout(() => {
            $(".ag-floating-filter-input").attr("placeholder", "Filter");
        }, 100);
    }

    onRaterGridReadyModal(params) {
        this.raterGridApi = params.api;
        this.sizeToFit(this.raterGridApi);
    }

    createAvailableHeaders() {
        let columnDefs = new Array();

        let nameHeader = {
            headerName: 'Name',
            field: 'AssessmentName',
            minWidth: 200,
            width: 200,
            suppressSizeToFit: false,
            cellRenderer: function (params) {
                return '<div style="overflow:hidden !important;text-overflow:ellipsis;">' + params.value + '</div>';
            }
        };
        columnDefs.push(nameHeader);

        let quantityHeader = {
            headerName: 'Quantity',
            field: 'Amount',
            minWidth: 120,
            width: 120,
            suppressSizeToFit: true,
            cellRenderer: function (params) {
                return '<div style="overflow:hidden !important;text-overflow:ellipsis;">' + params.value + '</div>';
            }
        };
        columnDefs.push(quantityHeader);
        
        return columnDefs;
    }

    createAssignedHeaders() {
        let columnDefs = new Array();

        let nameHeader = {
            headerName: 'Assessment',
            field: 'AssessmentName',
            minWidth: 175,
            width: 250,
            headerCheckboxSelection: true,
            headerCheckboxSelectionFilteredOnly: true,
            checkboxSelection: true,
            suppressSizeToFit: false,
            cellRenderer: function (params) {
                //return '<div style="overflow:hidden !important;text-overflow:ellipsis;">' + params.value + '</div>';
                return params.value;
            }
        };
        columnDefs.push(nameHeader);

        let statusHeader = {
            headerName: 'Status',
            field: 'Status',
            minWidth: 110,
            width: 110,
            suppressSizeToFit: true,
            cellRenderer: function (params) {
                return '<div style="overflow:hidden !important;text-overflow:ellipsis;">' + params.value + '</div>';
            }
        };
        columnDefs.push(statusHeader);

        let completedHeader = {
            headerName: 'Send date',
            field: 'ScheduledDate',
            minWidth: 175,
            width: 200,
            suppressSizeToFit: false,
            cellRenderer: function (params) {
                return params.value;
            }
        };
        columnDefs.push(completedHeader);

        let expiresOnHeader = {
            headerName: 'Expires on',
            field: 'ExpirationDate',
            minWidth: 175,
            width: 200,
            suppressSizeToFit: false,
            cellRenderer: function (params) {
                return params.value;
            }
        };
        columnDefs.push(expiresOnHeader); 

        return columnDefs;
    }

    createAssignedHeaders360() {
        let columnDefs = new Array();

        let nameHeader = {
            headerName: 'Assessment',
            field: 'AssessmentName',
            minWidth: 175,
            width: 250,
            headerCheckboxSelection: true,
            headerCheckboxSelectionFilteredOnly: true,
            checkboxSelection: true,
            suppressSizeToFit: false,
            cellRenderer: function (params) {
                //return '<div style="overflow:hidden !important;text-overflow:ellipsis;">' + params.value + '</div>';
                return params.value;
            }
        };
        columnDefs.push(nameHeader);

        let completedHeader = {
            headerName: 'Send date',
            field: 'ScheduledDate',
            minWidth: 175,
            width: 200,
            suppressSizeToFit: false,
            cellRenderer: function (params) {
                return params.value;
            }
        };
        columnDefs.push(completedHeader);

        let expiresOnHeader = {
            headerName: 'Expires on',
            field: 'ExpirationDate',
            minWidth: 175,
            width: 200,
            suppressSizeToFit: false,
            cellRenderer: function (params) {
                return params.value;
            }
        };
        columnDefs.push(expiresOnHeader);

        let statusHeader = {
            headerName: 'Status',
            field: 'Status',
            minWidth: 110,
            width: 110,
            suppressSizeToFit: true,
            cellRenderer: function (params) {
                return '<div style="overflow:hidden !important;text-overflow:ellipsis;">' + params.value + '</div>';
            }
        };
        columnDefs.push(statusHeader);

        let generationHeader = {
            headerName: 'Ready for generation',
            field: 'ReadyForGeneration',
            minWidth: 110,
            width: 210,
            suppressSizeToFit: true,
            cellRenderer: function (params) {

                let content = "";
                if (params.data["ReadyForGeneration"]) {
                    content = "Yes";
                } else {
                    content = "No";
                }
                return '<div style="overflow:hidden !important;text-overflow:ellipsis;">' + content + '</div>';
            }
        };
        columnDefs.push(generationHeader);

        return columnDefs;
    }

    createCompletedHeaders() {
        let columnDefs = new Array();

        let nicheHeader = {
            headerName: 'Assessment',
            field: 'AssessmentName',
            minWidth: 150,
            width: 150,
            headerCheckboxSelection: true,
            headerCheckboxSelectionFilteredOnly: true,
            checkboxSelection: true,
            suppressSizeToFit: false,
            cellRenderer: function (params) {
                return params.value;
                //return '<div style="overflow:hidden !important;text-overflow:ellipsis;">' + params.value + '</div>';

            }
        };
        columnDefs.push(nicheHeader);

        let completedHeader = {
            headerName: 'Completed on',
            field: 'CompletedOnDateTime',
            minWidth: 175,
            width: 175,
            sort: "desc",
            suppressSizeToFit: true,
            cellRenderer: function (params) {
                return params.value;
            }
        };
        columnDefs.push(completedHeader);

        return columnDefs;
    }

    onSelectionChanged(event) {
        console.log("onSelectionChanged ", event);
        var rowCount = event.api.getSelectedNodes().length;
        console.log("selection changed, ", rowCount + " rows selected");

        if (rowCount > 0) {
            this.canAddTags = true;
            let rows = this.getSelectedRows(this.gridApi);

            let assessmentInProgress = false;
            rows.forEach((client) => {
                console.log(client);
                if (client.Status != "Not started") {
                    assessmentInProgress = true;
                    return;
                }
            });
            if (!assessmentInProgress) {
                this.canDelete = true;
            } else {
                this.canDelete = false;
            }
        } else {
            this.canDelete = false;
            this.canAddTags = false;
        }

        if (rowCount == 1) {
            this.canCopy = true;
            this._Globals.assignedCanConversionRate = true;
        } else {
            this.canCopy = false;
            this._Globals.assignedCanConversionRate = false;
        }

        if (rowCount == 1) {
            let rows = this.getSelectedRows(this.gridApi);

            let is360 = true;
            rows.forEach((assessment) => {
                console.log(assessment);
                if (!assessment.Is360) {
                    is360 = false;
                    return;
                }
            });
            if (is360) {
                this.canAddRaters = true;
            } else {
                this.canAddRaters = false;
            }
        } else {
            this.canAddRaters = false;
        }

        if (rowCount > 0) {
            this.canUpdate = true;
            this.assignedCanSendReminder = true;
        } else {
            this.canUpdate = false;
            this.assignedCanSendReminder = false;
        }

        if (rowCount >= 1) {
            this.completedCanEnableResults = true;
            this.completedCanArchiveAssessments = true;
            this.canRestoreAssessments = true;

        } else {
            this.completedCanEnableResults = false;
            this.completedCanArchiveAssessments = false;
            this.canRestoreAssessments = false;
        }

    }

    onRowClicked(e) {
        console.log(e);
        if (e.event.target !== undefined) {
            let data = e.data;

            //if (this.currentSelectedTab == 0 || this.currentSelectedTab == 0.2) {
            //    this.openAssignAssessmentModal();
            //}

            if (this.currentSelectedTab == 1.2) {
                if (data.Status == "Completed") {
                    console.log('Navigate');
                    //this.router.navigate(['/app/co_a_report', data.Id, 'manage_assessments_assigned', 0]);
                }
            }

            if (this.currentSelectedTab == 2 || this.currentSelectedTab == 2.2) {
                this._router.navigate(['/app/co_a_report', data.Id, 'manage_clients', 1]);
            }

        }
    }

    //-----------------------------------ag-grid methods--------------------------------------
    getSelectedRows(gridApi): any {
        console.log("SELECTED", gridApi.getSelectedRows());
        return gridApi.getSelectedRows();
    }

    deselectAllCheckBox(gridApi) {
        gridApi.forEachNode(function (node) {
            node.setSelected(false);
        });
        this.setAllInFalse();
    }

    /*------------------------------------------------------------------------*/
    /*---------------------ASSIGNED ASSESSMENTS-------------------------------*/
    /*------------------------------------------------------------------------*/
    
    /*sendReminder*/
    sendReminder() {
        if (this.assignedCanSendReminder) {
            let rows = this.getSelectedRows(this.gridApi);
            let assignmentIds = [];
            rows.forEach((client) => {
                console.log(client);
                assignmentIds.push(client.Id);
            });
            console.log("assignmentIds", assignmentIds);
            this.sendAssessmentReminder(assignmentIds);
        }
    }

    sendAssessmentReminder(assignmentIds: number[]) {
        if (!this.sendingEmail) {
            this.sendingEmail = true
            $('body, #sendReminder').css('cursor', 'wait');
            this._CoachService.postSendAssessmentReminder(assignmentIds).subscribe((data: any) => {
                console.log('response_PostSendAssessmentReminder', data);
                if (this._Globals.validationToken(data.result.Result)) {
                    if (data.result.Result == 1) {
                        this._toastr.success("Invitation email sent successfully", "ELI");
                    } else {
                        this._toastr.error("We are sorry. An error occurred while trying to send the invitation email.", "ELI");
                    }
                }
                $('body, #sendReminder').css('cursor', 'default');
                this.sendingEmail = false;
            });
        }
    }

    formatAMPM(date) {
        console.log(date);
        var hours = date.getHours();
        var minutes = date.getMinutes();
        var ampm = hours >= 12 ? 'pm' : 'am';
        hours = hours % 12;
        hours = hours ? hours : 12; // the hour '0' should be '12'
        minutes = minutes < 10 ? '0' + minutes : minutes;
        var strTime = hours + ':' + minutes + ' ' + ampm;
        return strTime;
    }

    setCurrentMinHour(hour) {

        var currentHour = hour;
        console.log(currentHour);

        currentHour = currentHour.split(' ');
        currentHour[0] = parseInt(currentHour[0]);
        if (currentHour[0] == 12) {
            currentHour[0] = 0;
        }
        currentHour[0] = (currentHour[0] + 1) + "";

        if (currentHour[0].length == 1) {
            currentHour[0] = "0" + currentHour[0];
        }

        if (currentHour[0] == 12) {
            currentHour[1] = "PM";
        }

        currentHour = currentHour[0] + ":00 " + currentHour[1].toUpperCase();
        console.log('Hour for current Assignment', currentHour);
        $('#manageAssignedUpdateHour').val(currentHour);
    }

    /*extended Modal*/
    openExtendModal(from:string): void {
        if (this.canUpdate) {

            this.fromExpired = (from == 'expired') ? true : false;

            let selected = this.getSelectedRows(this.gridApi);
            console.log(selected);
            selected.forEach(item => {
                this.sentDate = this.getDate(new Date(item.ScheduledDate));
                this.expiresOn = this.getDate(new Date(item.ExpirationDate));

                let date = new Date(item.ScheduledDate);
                let today = new Date();

                let currentHour: any = new Date().toLocaleString('en-US', { hour: 'numeric', hour12: true });
                currentHour = currentHour.split(' ');

                this.assessmentHour = this.formatAMPM(new Date(item.ScheduledDate))
                console.log('assessment hour', this.assessmentHour.toUpperCase());

                if (date < today) {
                    this.setAllHoursAndSelectAssessmentHour();
                } else if (date > today) {
                    this.setAllHoursAndSelectAssessmentHour();
                } else {
                    this.addNewHour(parseInt(currentHour[0]) + 1, currentHour[1], false);
                }

                console.log("InvitationSent", item.InvitationSent);
                if (item.InvitationSent) {
                    this.pointerEvents = false;
                    $('.schedule .wc-date-container').css('opacity', 0.3);
                    $('#manageAssignedUpdateHour').css('opacity', 0.3);
                    return;
                }
            });

            $("#extendModal").modal({ backdrop: "static" });
            $('#extendModal').modal('show');
        }
    }

    closeExtendModal(): void {
        $('#extendedExpiresIn').val("")
        $('.schedule .wc-date-container').css('opacity', 1);
        $('#manageAssignedUpdateHour').css('opacity', 1);
        $('#extendModal').modal('hide');
        this.deselectAllCheckBox(this.gridApi);
        this.expiresOn = new Date();
        this.sentDate = new Date();
        this.pointerEvents = true;
        console.log('closeExtendModal');
        if (this.raterGridApi != undefined) this.deselectAllCheckBox(this.raterGridApi);
    }

    extendExpirationDate(): void {

        let selected = this.getSelectedRows(this.gridApi);
        let assignmentIds = [];

        selected.forEach(item => {
            assignmentIds.push(item.Id);
        });

        let expiresOn = this.getInputDate('expiresDatePicker');
        if (expiresOn == "") return;

        let sentDate;
        let scheduledTime = $('#manageAssignedUpdateHour').val();

        var d = new Date();
        var n = d.getTimezoneOffset();
        let timeOffset = (n / 60);

        //pointerEvents false means the invitation was sent         
        if (this.pointerEvents) {
            //INVITATION_NOT_SENT
            sentDate = this.getInputDate('editClientSentDateInput');
            if (sentDate == "") return;
        } else {
            //INVITATION_SENT
            sentDate = "";
            scheduledTime = "";
            timeOffset = 0;
        }

        this._CoachService.postUpdateAssignment(assignmentIds, expiresOn, sentDate, scheduledTime, timeOffset).subscribe((data: any) => {
            console.log('response_GetRaters', data);
            if (this._Globals.validationToken(data.result.Result)) {

                if (data.result.Result === 1) {
                    this._toastr.success("Expiration date extended successfully.", "ELI");

                    switch (this.currentSelectedTab) {
                        case 0:
                            this.getCoachAvailableAssessmentsByType(1);
                            break;
                        case 0.2:
                            this.getCoachAvailableAssessmentsByType(2);
                            break;
                        case 1:
                            this.getClientAssignedAssessmentsByType(1);
                            break;
                        case 1.2:
                            this.getClientAssignedAssessmentsByType(2);
                            break;
                        case 3:
                            this.getClientExpiredAssessmentsByType(1);
                            break;
                        case 3.2:
                            this.getClientExpiredAssessmentsByType(2);
                            break;
                    }
                    
                    this.closeExtendModal();
                }
                else {
                    this._toastr.error("An error happened. Please try again", "ELI");
                }
            }
        });
    }

    getDateTimePicker(pickerClass: string): string {
        let scheduledDate = $(`.${pickerClass} .wc-date-container span`).text();
        scheduledDate = scheduledDate.split(" ")[0].replace(/-/g, "/");
        console.log('scheduledFor', scheduledDate);

        if (new Date(scheduledDate) < new Date()) {
            this._toastr.warning("Please enter a date greater than the current date and time.", "ELI");
            return "";
        }

        return scheduledDate;
    }

    getInputDate(pickerClass: string): string {
        let scheduledDate = $(`#${pickerClass}`).val();
        scheduledDate = scheduledDate.split(" ")[0].replace(/-/g, "/");
        console.log('scheduledFor', scheduledDate);

        if ((new Date(scheduledDate) < new Date()) && pickerClass != 'editClientSentDateInput') {
            this._toastr.warning("Please enter a date greater than the current date and time.", "ELI");
            return "";
        }

        return scheduledDate;
    }

    onDateSelect(date, dateTimeId) {
        date = new Date(date + 'T00:00:00');
        $('input:radio[name=schedule]').eq(0).prop('checked', false);
        $('input:radio[name=schedule]').eq(1).prop('checked', true);

        date.setHours(0, 0, 0, 0);
        console.log('onDateSelect', date);

        var today = new Date();
        today.setHours(0, 0, 0, 0);
        console.log("today", today);

        var currentHour: any = new Date().toLocaleString('en-US', { hour: 'numeric', hour12: true });
        currentHour = currentHour.split(' ');

        if (date < today) {
            this._toastr.warning("Please enter a date and time greater than the current date and time.", "ELI");
            if (dateTimeId == 1) this.sentDate = this.getTodayDate2();
            if (dateTimeId == 2) this.expiresOn = this.getTodayDate2();
            this.importDate = new Date();

            //var time = new Date();
            //var currentHour: any = time.toLocaleString('en-US', { hour: 'numeric', hour12: true });
            //currentHour = currentHour.split(' ');
            //currentHour[0] = parseInt(currentHour[0]);
            //if (currentHour[0] == 12) {
            //    currentHour[0] = 0;
            //}
            //currentHour[0] = (currentHour[0] + 1) + "";

            //if (currentHour[0].length == 1) {
            //    currentHour[0] = "0" + currentHour[0];
            //}

            //if (currentHour[0] == 12) {
            //    currentHour[1] = "PM";
            //}
            //currentHour = currentHour[0] + ":00 " + currentHour[1];
            //console.log('current Hour', currentHour);
            //$('#hour').val(currentHour);
            //$('#importHour').val(currentHour);
            this.addNewHour(parseInt(currentHour[0]) + 1, currentHour[1], false);
        } else if (date > today) {
            this.setAllHoursAndSelectAssessmentHour();
        } else {
            this.addNewHour(parseInt(currentHour[0]) + 1, currentHour[1], false);
        }
    }

    setAllHoursAndSelectAssessmentHour() {
        this.addNewHour(0, "AM", true);
    }

    getCoachAssignedAssessmentsByType(assessmentType: number) {
        this._CoachService.getCoachAssignedAssessmentsByType(assessmentType).subscribe((data: any) => {
            if (this._Globals.validationToken(data.result.Result)) {
                let _data = JSON.parse(data.result.Data);
                console.log('getCoachAssignedAssessmentsByType_response', _data);

                if (assessmentType === 1) {
                    this.assignedRegularData = _data;
                } else {
                    this.assigned360Data = _data;
                }

                this.loading = false;
            }
        });
    }

    getAssessmentLink(assessmentId: number) {
        this._AssessmentsService.getAssessmentLink(assessmentId).subscribe((data: any) => {
            console.log('getAssessmentLink_response', data);
            if (this._Globals.validationToken(data.result.Result)) {
                if (data.result.Result == 1) {
                    console.log(data.result.Data);
                    let link = JSON.parse(data.result.Data);
                    $('#linkToCopy').text(link);

                    var $temp = $("<input>");
                    $("body").append($temp);
                    $temp.val($('#linkToCopy').text()).select();
                    document.execCommand("copy");
                    $temp.remove();

                    this._toastr.success('The assessment link has been copied to the clipboard', 'ELI');

                } else if (data.result.Result == 0) {
                    this._toastr.error("We are sorry. An error happened when trying to get the assessment link", "ELI");
                    
                }
            } 
        });
    }

    copy() {
        if (!this.canCopy) return;

        let data = this.getSelectedRows(this.gridApi);
        this.getAssessmentLink(data[0].Id);

    }

    unassignAssessments() {
        let rows = this.getSelectedRows(this.gridApi);
        let clientIds = [];
        rows.forEach((client) => {
            console.log(client);
            clientIds.push(client.Id);
        });

        this._CoachService.postUnassignAssessments(clientIds).subscribe((data: any) => {
            if (this._Globals.validationToken(data.result.Result)) {
                if (data.result.Result == 1) {
                    console.log('postUnassignAssessments',data);

                    this._toastr.success("Assessments unassigned successfully.", "ELI");
                    this.deselectAllCheckBox(this.gridApi);

                    switch (this.currentSelectedTab) {
                        case 0:
                            this.getCoachAvailableAssessmentsByType(1);
                            break;
                        case 0.2:
                            this.getCoachAvailableAssessmentsByType(2);
                            break;
                        case 1:
                            this.getClientAssignedAssessmentsByType(1);
                            break;
                        case 1.2:
                            this.getClientAssignedAssessmentsByType(2);
                            break;
                        case 3:
                            this.getClientExpiredAssessmentsByType(1);
                            break;
                        case 3.2:
                            this.getClientExpiredAssessmentsByType(2);
                            break;
                    }
                    this.inProgress = false;

                } else {
                    this._toastr.error("An error happend, please try again.", "ELI");
                    this.inProgress = false;
                }
                $('#confirmModal').modal('hide');
            }
        });
    }

    openConfirmModal() {
        if (!this.canDelete) {
            this._toastr.warning("Please select the assignments you want to revert.", "ELI");
            return;
        };

        $("#confirmModal").modal({ backdrop: "static" });
        $('#confirmModal').modal('show');
    }

    confirm() {
        this.inProgress = true;
        this.unassignAssessments();
    }

    assignRaters() {
        console.log('assignRaters');
        //if (!this._Globals.assignedCanAddRaters) return;
        let selected = this.getSelectedRows(this.gridApi);
        //this.clientId = selected[0].ClientId;
        //this.ratersHeaders = this.createRatersHeaders();
        this.getRaters(selected[0].Id, true);
        this.showModal();
    }

    getRaters(assignmentId: number, refreshData: boolean, oneOpen?:number) {
        console.log('getRaters');
        this.assignmentId = assignmentId;

        this._ClientsService.getRaters(this.assignmentId).subscribe((data: any) => {
            console.log('response_GetRaters', data);

            if (this._Globals.validationToken(data.result.Result)) {

                let _data = JSON.parse(data.result.Data);
                console.log('_data', _data);
                
                this.pristineRaters = JSON.parse(data.result.Data);
                
                if (this.addedRaters.length > 0 || this.editedRaters.length > 0 && refreshData) {
                    //updating the properties for edited entries
                    _data.forEach((item, index) => {
                        for (var i = 0; i < this.editedRaters.length; i++) {
                            if (item.Email == this.editedRaters[i].Email) {
                                _data[index] = this.editedRaters[i];
                            }
                        }
                    });
                    this.raters = _data.concat(this.addedRaters);
                    console.log('raters', this.raters);
                } else {
                    //from database
                    if (refreshData) {
                        this.raters = _data;

                        for (var i = 0; i < this.raters.length; i++) {
                            if (i == 0) {
                                $("#acc" + this.raters[i].RelationshipId).insertAfter('#forFirstelement');
                            } else {
                                let beforeElement = this.raters[(i - 1)].RelationshipId;
                                $("#acc" + this.raters[i].RelationshipId).insertBefore('#acc' + beforeElement);
                            }

                            $('#acc' + this.raters[i].RelationshipId).css('display', 'block');
                            $('#acc' + this.raters[i].RelationshipId).removeClass('accHide');
                            $('#acc' + this.raters[i].RelationshipId).addClass('accOpen');
                            //$('#relationships').val(r.RelationshipId);
                        }
                    } else {
                        //this.arrActiveCategories.forEach((r) => {
                        for (var i = 0; i < this.arrActiveCategories.length; i++) {
                            if (i == 0) {
                                $("#acc" + this.arrActiveCategories[i]).insertAfter('#forFirstelement');
                            } else {
                                let beforeElement = this.arrActiveCategories[(i - 1)];
                                $("#acc" + this.arrActiveCategories[i]).insertAfter('#acc' + beforeElement);
                            }
                            $('#acc' + this.arrActiveCategories[i]).css('display', 'block');
                            $('#acc' + this.arrActiveCategories[i]).removeClass('accHide');
                            $('#acc' + this.arrActiveCategories[i]).addClass('accOpen');
                            //$('#relationships').val(r); 
                        }
                    }

                    this.checkRatersAmount();

                    if (!this.executed) {
                        this.executed = true;
                        let pristineCategories = $('.accOpen');
                        console.log(pristineCategories);

                        for (var i = 0; i < $('.accOpen').length; i++) {
                            let r = pristineCategories[i].id.match(/\d/g).join(',');
                            r = r.replace(",", "");
                            this.pristineCategories.push(parseInt(r));
                        }
                    }
                    

                    if (oneOpen > 0) {
                        //open the first catefory
                        let firstElement = $('.accOpen a');
                        firstElement[0].click();
                        firstElement[0].children[0].children[1].classList.value = 'fas fa-angle-up';
                    }
                    //this.drawData();
                }

                this.loading = false;
                //this.sizeToFit(this.raterGridApi);
            }
        });
    }

    checkRatersAmount() {
        console.log('checkRatersAmount');
        let accOpen = $('.accOpen').length;
        console.log(accOpen);

        if (accOpen == 0) {
            //$('#mainAccordion .panel').css('display', 'none');
            this.noRaters = true;
            //$('#relationships option')[0].selected = true;
        } else {
            this.noRaters = false;
        }
    }

    showModal() {
        $("#ecRatersModal").modal({ backdrop: "static" });
        $('#ecRatersModal').modal('show');
    }

    closeModal() {
        $('#ecRatersModal').modal('hide');
        this.addedRaters = [];
        this.editedRaters = [];
        this.deletedRaters = [];
        this.raters = [];
        this.arrActiveCategories = [];
        this.pristineCategories = [];
        this.executed = false;
        $('#mainAccordion .panel').css('display', 'none');
        //$('#relationships option')[0].selected = true;
        console.log('closeModal'); 
        $('.acc div').removeClass('in');
        $('#mainAccordion .panel').removeClass('accOpen');
        $('#mainAccordion .panel').addClass('accHide');
        $('.panel a').css('color', '#63ceeb');
        $('.fa-angle-up').removeClass('fa-angle-up').addClass('fa-angle-down');
        this.hideConfirmCloseRatersModal();
        //this.deselectAllCheckBox(this.gridApi);
    }

    removeDuplicates(arr) {
        let s = new Set(arr);
        let it = s.values();
        return Array.from(it);
    }

    saveRaters() {
        //validation 
        let requirements = true;
        let missingRatersCategories = [];
        let missingRatersCategoriesIds = [];

        let activeCategories = $('.accOpen');
        if (activeCategories.length == 0) {
            this._toastr.warning('You must enter raters for at least one category', 'ELI')
            return;
        }

        console.log(activeCategories);
        for (var i = 0; i < activeCategories.length; i++) {
            let r = activeCategories[i].id.match(/\d/g).join(',');
            r = r.replace(",", "");
            missingRatersCategoriesIds.push(parseInt(r));
        }
        
        missingRatersCategoriesIds.forEach((item) => {
            let relationshipIndex = this.raterTypes.findIndex(x => x.Id === item);
            if (relationshipIndex != -1) {

                let relationshipsEntries = this.raters.filter((r) => { if (r.RelationshipId === item) return r });

                if (relationshipsEntries.length < this.raterTypes[relationshipIndex].Min) {
                    requirements = false;
                    $('a#' + this.raterTypes[relationshipIndex].Id + '.ng-tns-c2-0').css('color', 'red');
                    missingRatersCategories.push(' ' + this.raterTypes[relationshipIndex].Name);
                } else {
                    $('a#' + this.raterTypes[relationshipIndex].Id + '.ng-tns-c2-0').css('color', '#63ceeb');
                }
            }
        });
        let unic = this.removeDuplicates(missingRatersCategories);

        if (!requirements) {
            this._toastr.warning(`You have not entered the minimum raters required for the following categories: ${unic.join()}`, 'ELI');
            return;
        }

        let raters = this.raters.filter((r) => {
            if ('RecordStatus' in r) return r;
        });
        console.log("raters", raters);

        let missingData = false;
        raters.forEach((item) => {
            if (item.Email === "" || item.FirstName === "" || item.LastName === "") {
                missingData = true;
            }
        });

        if (missingData) {
            this._toastr.warning('Please complete all the fields for the entered raters.', 'ELI');
            return;
        };

        $("#ecSaveRatersModal").modal({ backdrop: "static" });
        $('#ecSaveRatersModal').modal('show');
        console.log('saveRaters');
        this.addRaterNext();
        $("input[type=radio]").eq(0).prop("checked", true);
    }

    /*raterTypesForModal*/
    openRaterTypesForModal() {
        this.raterTypesForModal.show(this, 0);
    }

    emailExistForRater(newRaterEmail:string) {
        const rater = this.raters.filter((item) => {
            return item.Email == newRaterEmail
        });
        console.log(rater);
        return rater;
    }

    sendEmail(e) { 
        let raterId;
        console.log(raterId);

        //button clicked
        if (e.target.nodeName == 'A') {
            raterId = e.target.parentElement.parentElement.dataset.raterid;
        }

        //child element clicked
        if (e.target.nodeName == 'SPAN' || e.target.nodeName == 'I') {
            raterId = e.target.parentElement.parentElement.parentElement.dataset.raterid
        }

        let regex = /tempId/;
        let result = regex.test(raterId);
        
        if (!result) {
            //if (this.assignedCanSend) {
            //let raters = this.getSelectedRows(this.raterGridApi);
            //raters.forEach(item => {
            //    ratesrIds.push(item.RaterId);
            //});

            this._RatersService.postSendEmail(this.assignmentId, [raterId]).subscribe((data: any) => {
                console.log('response_sendEmail', data);
                $('body').css('cursor', 'default');
                if (this._Globals.validationToken(data.result.Result)) {
                    if (data.result.Result == 1) {
                        this._toastr.success("Email messages sent successfully", "ELI");
                        //this.deselectAllCheckBox(this.raterGridApi);
                    } else if (data.result.Result == 0) {
                        this._toastr.error("We are sorry. An error happened when trying to send the email messages.", "ELI");
                    }
                    setTimeout(() => {
                       $('#mainAccordion').trigger("click");
                    }, 100);
                } 
            });
        //}
        }

    }

    arraysAreEqual(ary1, ary2) {
        console.log(JSON.stringify(ary1));
        console.log(JSON.stringify(ary2));
        return (JSON.stringify(ary1) == JSON.stringify(ary2));
    }

    /*Import Modal*/
    showImportModal() {
        console.log('showImportModal');

        let pristineCategories = [];
        let activeCategories = $('.accOpen');
        console.log(activeCategories);

        for (var i = 0; i < $('.accOpen').length; i++) {
            let r = activeCategories[i].id.match(/\d/g).join(',');
            r = r.replace(",", "");
            pristineCategories.push(parseInt(r));
        }

        if (!this.arraysAreEqual(this.raters, this.pristineRaters) || !this.arraysAreEqual(this.pristineCategories, pristineCategories)) {
            this._toastr.warning("Import raters is not allowed until you save your current changes", "ELI");
            return;
        }
        $("#importRaterModal").modal({ backdrop: "static" });
        $('#importRaterModal').modal('show');
    }

    closeImportModal() {
        $('#importRaterModal').modal('hide');
        $('#iFile').val('');
        this.fileName = "";
        this.blobFile = null;
        this.importRaterPageIdx = 0;
        console.log('closeImportModal');
    }

    showConfirmCloseRatersModal() {
        let pristineCategories = [];
        let activeCategories = $('.accOpen');
        console.log(activeCategories);

        for (var i = 0; i < $('.accOpen').length; i++) {
            let r = activeCategories[i].id.match(/\d/g).join(',');
            r = r.replace(",", "");
            pristineCategories.push(parseInt(r));
        }

        if (!this.arraysAreEqual(this.raters, this.pristineRaters) || !this.arraysAreEqual(this.pristineCategories, pristineCategories)) {
            $("#ecConfirmCloseRatersModal").modal({ backdrop: "static" });
            $('#ecConfirmCloseRatersModal').modal('show');
        } else {
            this.closeModal();
        }
    }

    hideConfirmCloseRatersModal() {
        $('#ecConfirmCloseRatersModal').modal('hide');
    }

    getBlobFile(event: any) {
        console.log(event);
        let file = event.srcElement.value;
        console.log(file);
        let str = String.raw`\fakepath`;
        file = file.split(str);
        file = file[1].substring(1);
        this.fileName = file;

        this.blobFile = event.target.files[0];
    }

    okImportRaters() {
        $('body').css('cursor', 'wait');
        this.blobToBase64(this.blobFile);
    }

    blobToBase64(blobFile) {
        var reader = new FileReader();
        reader.readAsDataURL(blobFile);
        reader.onload = () => {
            console.log("Base64 file", reader.result);
            let base64file: any = reader.result.toString();
            base64file = base64file.split(',');
            this.importClients(base64file[1].toString());
        };
        reader.onerror = function (error) {
            console.log('Error: ', error);
            $('body').css('cursor', 'default');
        };
    }

    importClients(base64file: string) {
        let importRatersDto = new ImportRatersDto();

        importRatersDto.clientId = this.client.id;
        importRatersDto.assignmentId = this.assignmentId;
        importRatersDto.data = base64file;

        let scheduledDate = $('.wc-date-container span').text();
        //this.scheduledDate = this.scheduledDate.slice(0, 10);
        let tempDate = scheduledDate.split(" ");
        scheduledDate = tempDate[0];
        scheduledDate = scheduledDate.replace(/-/g, "/");
        console.log('scheduledFor', scheduledDate);

        let language = $('#importLanguages').val();
        console.log('language', language);
        importRatersDto.language = language;


        let expiresIn = $('#importExpiresIn').val();
        console.log('expiresIn', expiresIn);

        let selectedHour = $('#importHour').val();
        //this.selectedGtmText = $("#gtm option:selected").text();
        //this.selectedGtmValue = $('#gtm').val();
        let scheduleSelected = $("input[name='schedule']:checked").val();

        console.log(selectedHour);
        console.log(scheduleSelected);

        let selectedGtmValue;
        var d = new Date();
        var n = d.getTimezoneOffset();
        selectedGtmValue = (n / 60);
        importRatersDto.timeOffSet = selectedGtmValue;

        if (expiresIn > 30) expiresIn = 30;
        importRatersDto.expiresIn = parseInt(expiresIn);

        if (scheduleSelected === "0") {
            importRatersDto.sendEmailInvitationNow = true;
            var today = new Date();
            var dd = today.getDate();
            var mm: any = today.getMonth() + 1;
            if (mm < 10) { mm = '0' + mm; }
            var yyyy = today.getFullYear();

            let date = `${mm}/${dd}/${yyyy}`;

            var time = new Date();
            var currentHour: any = time.toLocaleString('en-US', { hour: 'numeric', hour12: true });
            currentHour = currentHour.split(' ');
            importRatersDto.scheduledFor = date + " " + currentHour[0] + ":00 " + currentHour[1];

        } else {
            importRatersDto.sendEmailInvitationNow = false;
            //var sDate = scheduledDate.split('/');
            //importRatersDto.scheduledFor = sDate[1] + '/' + sDate[2] + '/' + sDate[0] + " " + selectedHour;

            let scheduledFor = $('.wc-date-container span').text();
            let scheduledForArr = scheduledFor.split(' ');
            scheduledFor = scheduledForArr[3];
            scheduledFor = scheduledFor.substr(5);
            scheduledFor = scheduledFor.replace(/-/g, "/");
            console.log('scheduledFor', scheduledFor);

            importRatersDto.scheduledFor = scheduledFor + " " + selectedHour;
        }

        console.log('importRatersDto', importRatersDto);

        this._CoachService.postImportRaters(importRatersDto).subscribe((data: any) => {
            console.log('response_PostImportRaters', data);
            if (this._Globals.validationToken(data.result.Result)) {
                let _data = JSON.parse(data.result.Data);
                console.log('_PostImportRaters data', _data);

                if (data.result.Result == 0) {
                    this._toastr.error("An error happened while trying to process the csv file.  Please verify that it is a valid file", "ELI");
                    $('body').css('cursor', 'default');
                } else if (data.result.Result == 1) {
                    this._toastr.success(`Total entries found: ${_data.TotalEntries} Imported: ${_data.SuccessEntries} Failed: ${_data.FailedEntries}`, "ELI");
                    this.getRaters(this.assignmentId, true);
                    this.closeImportModal();
                    $('body').css('cursor', 'default');
                }
            }
        });
    }

    importRaterNext() {
        if (this.blobFile == null) {
            this._toastr.warning("Please select an a .csv file.", "ELI");
            return;
        }

        this.importRaterPageIdx++;
        console.log(this.importRaterPageIdx);

        if (this.importRaterPageIdx == 1) {
            setTimeout(() => {
                var time = new Date();
                let currentHour: any = time.toLocaleString('en-US', { hour: 'numeric', hour12: true });
                currentHour = currentHour.split(' ');
                this.addNewHour(parseInt(currentHour[0]) + 1, currentHour[1], false);
            }, 100);
        }
    }

    importRaterPrev() {
        this.importRaterPageIdx--;
        console.log(this.importRaterPageIdx);
    }

    importHourChanged() {
        $('input:radio[name=schedule]').eq(0).prop('checked', false);
        $('input:radio[name=schedule]').eq(1).prop('checked', true);
    }

    addNewHour(minHour: number, type: string, useAssessmentHour: boolean) {
        if (minHour == 13) {
            minHour = 1;
        }

        let amHours = [];
        let pmHours = [];

        if (type === "AM") {
            for (var i = minHour; i <= 11; i++) {
                if (i >= 10) {
                    amHours.push(i + ":00 AM");
                } else {
                    amHours.push("0" + i + ":00 AM");
                }
            }
            //adding the rest pm hours
            amHours.push("12:00 PM");
            minHour = 1;
            for (var j = minHour; j < 12; j++) {
                if (j >= 10) {
                    pmHours.push(j + ":00 PM");
                } else {
                    pmHours.push("0" + j + ":00 PM");
                }
            }
        } else {
            if (minHour == 12) {
                amHours.push("12:00 PM");
                minHour = 1;
            }
            for (var i = minHour; i < 12; i++) {
                if (i >= 10) {
                    pmHours.push(i + ":00 PM");
                } else {
                    pmHours.push("0" + i + ":00 PM");
                }
            }
        }
        console.log("this.hours", this.hours);
        this.hours = amHours.concat(pmHours);
        //this.setCurrentMinHour();
        //$('#hour').val(currentHour);

        if (useAssessmentHour) {
            let currentHour: any = this.assessmentHour.split(' ');
            console.log(currentHour);
            currentHour[0] = currentHour[0].split(':')[0];
            console.log('length', currentHour[0].length);
            let hour = currentHour[0];
            if (hour.length == 1) {
                hour = "0" + currentHour[0];
            }
            setTimeout(() => {
                $('#manageAssignedUpdateHour').val(hour + ":00 " + currentHour[1].toUpperCase());
            }, 100);
        } else {
            $('#manageAssignedUpdateHour').val(this.hours[0]);
        }
    }

    showDeleteRatersConfirmationModal(e) {
        let showModal = false;
        let relationshipId;
        let raterId;

        //button clicked
        if (e.target.nodeName == 'A') {
            relationshipId = parseInt(e.target.parentElement.parentElement.dataset.relationshipid);
            raterId = e.target.parentElement.parentElement.dataset.raterid;
            for (var i = 0; i < 3; i++) {
                if (e.target.parentNode.parentNode.children[i].children[0].value != "") {
                    showModal = true;
                }
            }
        }

        //child element clicked
        if (e.target.nodeName == 'SPAN' || e.target.nodeName == 'I') {
            relationshipId = parseInt(e.target.parentElement.parentElement.parentElement.dataset.relationshipid);
            raterId = e.target.parentElement.parentElement.parentElement.dataset.raterid;
            for (var i = 0; i < 3; i++) {
                if (e.target.parentNode.parentNode.parentNode.children[i].children[0].value != "") {
                    showModal = true;
                }
            }
        }

        //get the relationship min
        let relationship = this.raterTypes.filter((rt) => {
            if (relationshipId == rt.Id) return rt;
        });

        let inputEntries = $('#acc' + relationshipId + ' .categoryEntries .row');
        if (showModal) {
            let raterPosition = this.raters.findIndex(x => x.RaterId === parseInt(raterId));
            if (raterPosition != -1) {
                if (this.raters[raterPosition].Status == 1) {
                    $("#ecConfirmDeleteRatersModal").modal({ backdrop: "static" });
                    $('#ecConfirmDeleteRatersModal').modal('show');
                } else {
                    this._toastr.warning('This rater cannot be deleted since she or he has already started or completed the assessment', 'ELI');
                    setTimeout(() => {
                        $('#relationships').trigger("click");
                    }, 10);
                }
            }
            else {
                $("#ecConfirmDeleteRatersModal").modal({ backdrop: "static" });
                $('#ecConfirmDeleteRatersModal').modal('show');
            }
            
        } else {
            if (inputEntries.length > relationship[0].Min) {
                this.deleteRaterEntry(e)
            } else {
                this._toastr.warning('You need a minimum of ' + relationship[0].Min + ' raters for this category', 'ELI');
                setTimeout(() => {
                    $('#relationships').trigger("click");
                }, 10);
            }
        }
    }

    hideDeleteRatersConfirmationModal() {
        $('#ecConfirmDeleteRatersModal').modal('hide');
    }

    showBulkDeleteRatersConfirmationModal(rtId) {
        this.bulkDeleteCategoryId = rtId;

        let categoryRaters = this.raters.filter((r) => {
            if (rtId == r.RelationshipId) return r;
        });

        if (categoryRaters.length > 0) {
            $('.BDMessage').text('Are you sure to want to remove all the raters for this category (the category will be removed as well)?');
        } else {
            $('.BDMessage').text('Are you sure you want to remove this category from this assessment?');
        }

        $("#ecBulkConfirmDeleteRatersModal").modal({ backdrop: "static" });
        $('#ecBulkConfirmDeleteRatersModal').modal('show');
    }

    hideBulkDeleteRatersConfirmationModal() {
        $('#ecBulkConfirmDeleteRatersModal').modal('hide');
    }

    confirmDeleteRaters() {
        this.inProgress = true;
        this.deleteRaterEntry(this.raterToDelete);
        //this.deleteSelectedRater();
    }

    confirmBulkDeleteRaters() {
        this.inProgress = true;
        this.removeCatergoryContent();
    }

    deleteRaters() {
        let raters = this.getSelectedRows(this.raterGridApi);
        let ratersIds = [];

        raters.forEach((rater) => {
            console.log("rater", rater);
            ratersIds.push(rater.RaterId);
        });

        this._CoachService.postDeleteRaters(this.assignmentId, ratersIds).subscribe((data: any) => {

            this.inProgress = false;
            console.log('postDeleteRaters_response', data);

            if (this._Globals.validationToken(data.result.Result)) {
                this.getRaters(this.assignmentId, true);
                this.hideDeleteRatersConfirmationModal();

                if (data.result.Result == 1) {
                    this._toastr.success("Rater(s) deleted successfully.", "ELI");
                    this.deselectAllCheckBox(this.raterGridApi);
                } else if (data.result.Result == 0) {
                    this._toastr.error("We are sorry.  Some of the selected raters cannot be removed because they have either already initiated the assessment or completed it.", "ELI");
                }
            }
        });
    }

    showNewRaterModal(action) {
        if (action == 'Add') {
            $("#email").removeClass('disabled');
            this.rater.email = "";
            this.rater.firstName = "";
            this.rater.lastName = "";
            $('#raterTypesSelect option').eq(0).prop('selected', false);
        } else {
            $("#email").addClass('disabled');
            this.rater.email = this.raterForEdit.Email;
            this.rater.firstName = this.raterForEdit.FirstName;
            this.rater.lastName = this.raterForEdit.LastName;
            $('#raterTypesSelect').val(this.raterForEdit.RelationshipId);
        }

        $("#assignedAddModal").modal({ backdrop: "static" });
        $('#assignedAddModal').modal('show');
        this.actionForRater = action;
    }

    closeNewRaterModal() {
        $('#ecSaveRatersModal').modal('hide');
        $('#ecRatersModal').css('overflow', 'auto');
        console.log('hide');
        this.addRaterPageIdx = 0;
    }

    validateEmail(email: string, raterPosition:number): boolean {
        if (email !== "") {
            console.log("email", email);

            var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
            let validEmail = regex.test(email);
            console.log('Valid', validEmail)
            if (validEmail) {
                let exist = this.raters.findIndex(x => x.Email === email);
                if (exist != -1 && raterPosition != exist) {
                    this._toastr.warning('The specified Email address is already a rater for this assessment.', "ELI");
                    setTimeout(() => {
                        $('#relationships').trigger("click");
                    }, 100);
                    return false;
                } else {
                    return true;
                }
            } else {
                this._toastr.warning('Please enter a valid email address', "ELI");
                setTimeout(() => {
                    $('#relationships').trigger("click");
                }, 100);
                return false;
            }
        }        
    }

    preventSpace(value: string, event: any, tagId: string) {
        if (value == null || value == "") {
            if (event.keyCode == 32) {
                return false;
            }
        }
        if (value == " ") {
            $(`#${tagId}`).val('');
        }
    }

    addRaterNext() {
        //this.addRaterPageIdx++;
        console.log(this.addRaterPageIdx);

        //if (this.addRaterPageIdx == 1) {
            setTimeout(() => {
                var time = new Date();
                let currentHour: any = time.toLocaleString('en-US', { hour: 'numeric', hour12: true });
                currentHour = currentHour.split(' ');
                this.addNewHour(parseInt(currentHour[0]) + 1, currentHour[1], false);
            }, 100);
        //}
    }

    addRaterPrev() {
        this.addRaterPageIdx--;
        console.log(this.addRaterPageIdx);
    }

    getLanguages() {
        this._AdminService.getLanguages().subscribe((data: any) => {
            console.log('languages', data.result);
            let result = data.result.Result;

            if (result <= -10) {
                //this.toastr.warning('Expired token please login again.', 'ELI');
                this._router.navigate(['/login']);
                this._Globals.deleteAllStorage();
                return;
            }

            let _data = JSON.parse(data.result.Data);
            this.languages = _data;
        });
    }

    getRaterTypesForCoach(refreshData:boolean) { 
        this._CoachService.getRaterTypesForCoach().subscribe((data: any) => {
            console.log('response_GetRaterTypesForCoach', data);

            if (this._Globals.validationToken(data.result.Result)) {
                let oneopen = $('.fa-angle-up').length;
                let _data = JSON.parse(data.result.Data);
                console.log('response_GetRaterTypesForCoach', _data);

                this.raterTypes = _data;
                this.rater.raterType = _data[0].Id;
                this.categoryMin = _data[0].Min;

                if (refreshData) {
                    let activeCategories = $('.accOpen');
                    console.log(activeCategories);
                    this.arrActiveCategories = [];
                    for (var i = 0; i < activeCategories.length; i++) {
                        let r = activeCategories[i].id.match(/\d/g).join(',');
                        r = r.replace(",", "");
                        this.arrActiveCategories.push(parseInt(r));
                    }

                    let selected = this.getSelectedRows(this.gridApi);
                    //this.clientId = selected[0].ClientId;
                    //this.ratersHeaders = this.createRatersHeaders();
                    this.getRaters(selected[0].Id, false, oneopen);
                    //this.showRelationshipsModal();
                }
            }
        });
    }

    finishSaveRaters() {
        this.scheduledDate = $('.wc-date-container span').text();
        //this.scheduledDate = this.scheduledDate.slice(0, 10);
        let tempDate = this.scheduledDate.split(" ");
        this.scheduledDate = tempDate[0];
        this.scheduledDate = this.scheduledDate.replace(/-/g, "/");
        console.log('scheduledFor', this.scheduledDate);

        this.language = $('#languages').val();
        console.log('language', this.language);

        this.expiresIn = $('#expiresIn').val();
        console.log('expiresIn', this.expiresIn);

        this.selectedHour = $('#hour').val();
        //this.selectedGtmText = $("#gtm option:selected").text();
        //this.selectedGtmValue = $('#gtm').val();
        this.scheduleSelected = $("input[name='schedule']:checked").val();

        console.log(this.selectedHour);
        console.log(this.scheduleSelected);

        let rater = new RaterDto();
        rater.ClientId = this.client.id;
        rater.AsignmentId = this.assignmentId;
        rater.Language = this.language;

        if (this.scheduleSelected === "0") {
            var d = new Date();
            var n = d.getTimezoneOffset();
            this.selectedGtmValue = (n / 60);
        }

        rater.TimeOffSet = this.selectedGtmValue;
        if (this.expiresIn > 30) this.expiresIn = 30;
        rater.ExpiresIn = parseInt(this.expiresIn);

        if (this.scheduleSelected === "0") {
            rater.SendEmailInvitationNow = true;
            var today = new Date();
            var dd = today.getDate();
            var mm: any = today.getMonth() + 1;
            if (mm < 10) { mm = '0' + mm; }
            var yyyy = today.getFullYear();

            let date = `${mm}/${dd}/${yyyy}`;

            var time = new Date();
            var currentHour: any = time.toLocaleString('en-US', { hour: 'numeric', hour12: true });
            currentHour = currentHour.split(' ');
            rater.ScheduledFor = date + " " + currentHour[0] + ":00 " + currentHour[1];
        } else {
            rater.SendEmailInvitationNow = false;
            //var sDate = this.scheduledDate.split('/');
            //rater.ScheduledFor = sDate[1] + '/' + sDate[2] + '/' + sDate[0] + " " + this.selectedHour;
            ////rater.ScheduledTime = this.selectedHour;

            let scheduledFor = $('.wc-date-container span').text();
            let scheduledForArr = scheduledFor.split(' ');
            scheduledFor = scheduledForArr[3];
            scheduledFor = scheduledFor.substr(5);
            scheduledFor = scheduledFor.replace(/-/g, "/");
            console.log('scheduledFor', scheduledFor);

            rater.ScheduledFor = scheduledFor + " " + this.selectedHour;
        }

        let raters = this.raters.filter((r) => {
            if ('RecordStatus' in r) return r;
        });
        console.log("raters", raters);

        rater.Raters = raters.concat(this.deletedRaters);;
        console.log("save Rater", rater);

        $('body').css('cursor', 'wait');
        this.addingRater = true;
        
        this._ClientsService.postSaveRaters(rater).subscribe((data: any) => {
            console.log('response_PostSaveRater', data);
            $('body').css('cursor', 'default');
            if (this._Globals.validationToken(data.result.Result)) {

                switch (data.result.Result) {
                    case -1:
                        this._toastr.warning('The specified user is already a rater for this assessment.', 'ELI');
                        break;
                    case 0:
                        this._toastr.error('We are sorry. An error happend while trying to save the client.', 'ELI');
                        break;
                    case 1:
                        this.addedRaters = [];
                        this.editedRaters = [];
                        this.deletedRaters = [];
                        this.getRaters(this.assignmentId, true);
                        this._toastr.success('Raters added successfully.', 'ELI');
                        this.closeNewRaterModal();
                        $('.acc div').removeClass('in');
                        $('#mainAccordion .panel').removeClass('accOpen');
                        $('#mainAccordion .panel').addClass('accHide');
                        //this.closeModal();
                        break;
                }
                this.addingRater = false;
            }
        });
    }

    /*-------------------------------------------------------------*/
    /*----------------COMPLETED ASSESSMENTS------------------------*/
    /*-------------------------------------------------------------*/

    enableClientSeeResults() {
        if (this.completedCanEnableResults) {
            $('body').css('cursor', 'wait');
            var selected = this.getSelectedRows(this.gridApi);
            console.log(selected);

            let assignmentIds = [];
            selected.forEach((item) => {
                console.log(item.Id);
                assignmentIds.push(item.Id)
            })
            this._CoachService.postEnableClientSeeResults(assignmentIds, true).subscribe((data: any) => {
                console.log("PostEnableClientSeeResults_response", data);
                if (this._Globals.validationToken(data.result.Result)) {
                    console.log(data);
                    this._toastr.success("Results enabled successfully.", "ELI");
                    $('body').css('cursor', 'default');
                }
            });
        }
    }

    /*Archive Assessments*/
    openArchiveAssessmentsConfirmationModal() {
        if (this.completedCanArchiveAssessments) {
            $("#archiveConfirmationModal").modal({ backdrop: "static" });
            $('#archiveConfirmationModal').modal('show');
        }
    }

    closeArchiveAssessmentsConfirmationModal() {
        if (this.completedCanArchiveAssessments) {
            $('#archiveConfirmationModal').modal('hide');
            this.completedCanArchiveAssessments = false;
            this.completedCanEnableResults = false;
        }
    }

    archiveAssessments() {
        if (this.completedCanArchiveAssessments) {
            var selected = this.getSelectedRows(this.gridApi);

            this.archiving = true;
            console.log(selected);
            let assignmentIds = [];

            selected.forEach((item) => {
                console.log(item.Id);
                assignmentIds.push(item.Id)
            });
            console.log(assignmentIds);

            let data = {
                "AssignmentIds": assignmentIds,
                "Archived": 1
            };

            this._CoachService.postArchiveAssessments(this._CryptoJs.encrypt(JSON.stringify(data), 'Os6v70$B&E!H@MlKfTj9nZ34tPw!z%8*')).subscribe((data: any) => {
                if (this._Globals.validationToken(data.result.Result)) {
                    console.log('postArchiveAssessments_response', data.result.Result);

                    switch (data.result.Result) {
                        case -1:
                            this._toastr.error('We are sorry. Some of the selected assessments could not be archived', 'ELI');
                            break;

                        case 0:
                            this._toastr.error('We are sorry. An unexpected error happened when trying to archive the assessments', 'ELI');
                            break;

                        case 1:
                            this._toastr.success('Assessment archived successfully');
                            break;
                    }
                    this.archiving = false;
                    console.log(this.currentSelectedTab);
                    if (this.currentSelectedTab === 2) {
                        this.getClientCompletedAssessmentsByType(1);
                    } else {
                        this.getClientCompletedAssessmentsByType(2);
                    }
                    this.closeArchiveAssessmentsConfirmationModal();
                }
            });

        }
    }

    /*Restore assessments*/
    openRestoreAssessmentsConfirmationModal() {
        if (this.canRestoreAssessments) {
            $("#restoreConfirmationModal").modal({ backdrop: "static" });
            $('#restoreConfirmationModal').modal('show');
        }
    }

    closeRestoreAssessmentsConfirmationModal() {
        if (this.canRestoreAssessments) {
            $('#restoreConfirmationModal').modal('hide');
            this.canRestoreAssessments = false;
            this.completedCanEnableResults = false;
        }
    }
    restoreAssessments() {
        if (this.canRestoreAssessments) {
            var selected = this.getSelectedRows(this.gridApi);

            this.restoring = true;
            console.log(selected);
            let assignmentIds = [];

            selected.forEach((item) => {
                console.log(item.Id);
                assignmentIds.push(item.Id)
            });
            console.log(assignmentIds);

            let data = {
                "AssignmentIds": assignmentIds,
                "Archived": 0
            };

            this._CoachService.postArchiveAssessments(this._CryptoJs.encrypt(JSON.stringify(data), 'Os6v70$B&E!H@MlKfTj9nZ34tPw!z%8*')).subscribe((data: any) => {
                if (this._Globals.validationToken(data.result.Result)) {
                    console.log('postArchiveAssessments_response', data.result.Result);

                    switch (data.result.Result) {
                        case -1:
                            this._toastr.error('We are sorry. Some of the selected assessments could not be restored', 'ELI');
                            break;

                        case 0:
                            this._toastr.error('We are sorry. An unexpected error happened when trying to restore the assessment(s)', 'ELI');
                            break;

                        case 1:
                            this._toastr.success('Assessment(s) restored successfully');
                            break;
                    }
                    this.restoring = false;
                    if (this.currentSelectedTab === 4) {
                        this.getClientArchivedAssessments(1);
                    } else {
                        this.getClientArchivedAssessments(2);
                    }
                    this.closeRestoreAssessmentsConfirmationModal();
                }
            });

        }
    }


    /*-------------------------------------------------------------*/
    /*------------------EXPIRED ASSESSMENTS------------------------*/
    /*-------------------------------------------------------------*/

    getMinNumber(objIndex) {
        let min = this.raterTypes[objIndex].Min
        return new Array(min);
    }

    addRelationships() {
        console.log('addRelationships');
        let standartRows = this.getSelectedRows(this.raterTypesStandartGridApi);
        let globalRows = this.getSelectedRows(this.raterTypesCustomGridApi);
        console.log('rows', standartRows);
        console.log('rows', globalRows);

        let rows = standartRows.concat(globalRows); 
        
        let arrActiveCategories = [];
        let activeCategories = $('.accOpen');
        console.log(activeCategories);
        for (var i = 0; i < activeCategories.length; i++) {
            let r = activeCategories[i].id.match(/\d/g).join(',');
            r = r.replace(",", "");
            arrActiveCategories.push(parseInt(r));
        }
        
        rows.forEach((r) => {
            let categoryIndex = arrActiveCategories.findIndex(x => x === r.Id);
            if (categoryIndex == -1) {
                this.createCategoryContent(r.Id, r.Min, rows[rows.length - 1].Id);
            }
        });
        this.hideRelationshipsModal();
    }
    
    drawData(relationshipId: number, relationshipMin: number, e?) {
        console.log(e);
        //reset all angle icons down
        if (this.lastRelationshipClicked != relationshipId) {
            $('.fa-angle-up').removeClass('fa-angle-up').addClass('fa-angle-down');
        }

        if (e != undefined) {
            //h4 clicked
            if (e.target.nodeName == 'H4') {
                if (e.target.nextElementSibling.classList.value == 'fas fa-angle-up') {
                    e.target.nextElementSibling.classList.value = 'fas fa-angle-down';
                } else {
                    e.target.nextElementSibling.classList.value = 'fas fa-angle-up';
                }
            }

            //a clicked
            if (e.target.nodeName == 'DIV') {
                if (e.target.children[1].classList.value == 'fas fa-angle-up') {
                    e.target.children[1].classList.value = 'fas fa-angle-down';
                } else {
                    e.target.children[1].classList.value = 'fas fa-angle-up';
                }
            }

            //i clicked
            if (e.target.nodeName == 'I') {
                if (e.target.classList.value == 'fas fa-angle-up') {
                    e.target.classList.value = 'fas fa-angle-down';
                } else {
                    e.target.classList.value = 'fas fa-angle-up';
                }
            }
        }

        this.lastRelationshipClicked = relationshipId;

        let filteredRaters = this.raters.filter((r) => {
            if (r.RelationshipId === relationshipId) return r;
        });
        console.log('filteredRaters', filteredRaters);

        //display min message if category doesnt have enought raters
        this.displayMinMessage(relationshipId);
        
        $('.categoryEntries').html(``);

        let disabled = 'disabled';
        if (filteredRaters.length > 0) {
            filteredRaters.forEach((item) => {
                let raterId = item.RaterId;
                if (item.tempIdCounter) {
                    disabled = ''
                    raterId = item.tempIdCounter
                }

                let classes = 'd-none d-sm-inline-block btn btn-sm btn-primary sendEntry';
                if (item.tempIdCounter || item.Status == 3) {
                    classes = 'd-none d-sm-inline-block btn btn-sm btn-gray';
                }
                $('.categoryEntries').append(`
                    <div class="row" data-raterId="${raterId}" data-relationshipId="${relationshipId}" style="padding: 0px 2px;display: inline-flex;width: 100%;margin: 0px;position: relative;top: -13px;">
                        <div class="" style="padding: 0px;width:25%;min-width:150px;"><input style="width:100%;" autocomplete="new-password" class="raterEntry form-control" placeholder="First Name" name=FirstName type="text" value="${item.FirstName}" /></div>
                        <div class="" style="padding: 0 0 0 10px;width:25%;min-width:150px;"><input style="width: 100%;" autocomplete="new-password" class="raterEntry form-control" placeholder="Last Name" name="LastName" type="text" value="${item.LastName}" /></div>
                        <div class="" style="padding: 0 10px 0 10px;width:30%;min-width:150px;"><input style="width: 100%;" autocomplete="new-password" class="raterEntry form-control" placeholder="Email" name="Email" ${disabled} type="text" value="${item.Email}" /></div>
                        <div class="dinamicResponsive" style="width:20%;">
                            <a _ngcontent-c2="" class="${classes}">
                                <span>Resend Invitation</span>
                                <i _ngcontent-c2="" class="fas fa-paper-plane text-white-50"><span _ngcontent-c2="" class="button-text"> Resend Invitation</span></i>
                            </a>
                            <a _ngcontent-c2="" class="d-none d-sm-inline-block btn btn-sm btn-red deleteRaterEntry">
                                <span>Delete</span>
                                <i _ngcontent-c2="" class="fas fa-trash text-white-50"><span _ngcontent-c2="" class="button-text"> Delete</span></i>
                            </a>
                        </div>    
                    </div>
                `);
            });

            //adding the minimun rater entries
            for (var i = 0; i < relationshipMin - filteredRaters.length; i++) {
                this.addNewRaterEntry(relationshipId);  
            }
        } else {
            for (var i = 0; i < relationshipMin; i++) {
                this.addNewRaterEntry(relationshipId);   
            }
        }
    }

    displayMinMessage(relationshipId: number) {
        //display min message if category doesnt have enought raters
        let categoryRaters = this.raters.filter((r) => {
            if (relationshipId == r.RelationshipId) return r;
        });

        let rt = this.raterTypes.findIndex(x => x.Id === relationshipId);
        let min;
        if (rt != -1) {
            min = this.raterTypes[rt].Min;
        }

        if (categoryRaters.length < min) {
            $('.categoryMinMessage span').text('You need a minimum of ' + min + ' raters for this category.');
            $('.removeButtonText').text('Remove Category');
        } else {
            $('.categoryMinMessage span').text('');
            $('.removeButtonText').text('Remove All');
        }
    }

    addNewRaterEntry(relationshipId: number) {
        //get the relationship min
        let relationship = this.raterTypes.filter((rt) => {
            if (relationshipId == rt.Id) return rt;
        });

        let classes = "";
        //let inputEntries = $('#acc' + relationshipId + ' .categoryEntries .row');
        if (relationship.length != 0) {
            classes = 'd-none d-sm-inline-block btn btn-sm btn-red deleteRaterEntry';
            //if (inputEntries.length >= relationship[0].Min) {
            //    classes = 'd-none d-sm-inline-block btn btn-sm btn-red deleteRaterEntry';
            //} else {
            //    classes = 'btn btn-sm btn-gray';
            //}

            $('.categoryEntries').append(`
                    <div class="row" data-raterId="${this.tempId}${this.counter}" data-relationshipId="${relationshipId}" style="padding: 0px 2px;display: inline-flex;width: 100%;margin: 0px;position: relative;top: -13px;">
                        <div class="" style="padding: 0px;width:25%;min-width:150px;"><input style="width:100%;" autocomplete="new-password" class="raterEntry form-control" placeholder="First Name" name=FirstName type="text" value="" /></div>
                        <div class="" style="padding: 0 0 0 10px;width:25%;min-width:150px;"><input style="width: 100%;" autocomplete="new-password" class="raterEntry form-control" placeholder="Last Name" name="LastName" type="text" value="" /></div>
                        <div class="" style="padding: 0 10px 0 10px;width:30%;min-width:150px;"><input style="width: 100%;" autocomplete="new-password" class="raterEntry form-control" placeholder="Email" name="Email" type="text" value="" /></div>
                        <div class="dinamicResponsive" style="width:20%;">
                            <a _ngcontent-c2="" class="d-none d-sm-inline-block btn btn-sm btn-gray">
                                <span _ngcontent-c2="">Resend Invitation</span>
                                <i _ngcontent-c2="" class="fas fa-paper-plane text-white-50"><span _ngcontent-c2="" class="button-text"> Resend Invitation</span></i>
                            </a>
                            <a _ngcontent-c2="" class="${classes}">
                                <span _ngcontent-c2="">Delete</span>
                                <i _ngcontent-c2="" class="fas fa-trash text-white-50"><span _ngcontent-c2="" class="button-text"> Delete</span></i>
                            </a>
                        </div>                        
                    </div>
                `);
            this.counter++;
        }
    }
    
    ngAfterContentInit() {
        $(document).on('click', '#ecRatersModal .deleteRaterEntry', (e) => {
            this.showDeleteRatersConfirmationModal(e);
            this.raterToDelete = e;
        });

        $(document).on('focusout', '#ecRatersModal .raterEntry', (e) => {
            this.editRaterEntry(e);
        }); 

        $(document).on('click', '#ecRatersModal .sendEntry', (e) => {
            $('body').css('cursor', 'wait');
            this.sendEmail(e);
        });
        this.checkRatersAmount();
    }

    deleteRaterEntry(e:any) {
        console.log('click event', e);

        let raterId;            

        //button clicked
        if (e.target.nodeName == 'A') {
            raterId = e.target.parentElement.parentElement.dataset.raterid;
        }

        //child element clicked
        if (e.target.nodeName == 'SPAN' || e.target.nodeName == 'I' ) {
            raterId = e.target.parentElement.parentElement.parentElement.dataset.raterid;
        }

        console.log('raterId', raterId);

        let regex = /tempId/;
        let result = regex.test(raterId);
        let relationshipId;

        //button clicked
        if (e.target.nodeName == 'A') {
            relationshipId = parseInt(e.target.parentElement.parentElement.dataset.relationshipid);
        }

        //child element clicked
        if (e.target.nodeName == 'SPAN' || e.target.nodeName == 'I' ) {
            relationshipId = parseInt(e.target.parentElement.parentElement.parentElement.dataset.relationshipid);
        }
        console.log('relationshipId', relationshipId);

        if (!result) {
            //in database
            let raterPosition = this.raters.findIndex(x => x.RaterId === parseInt(raterId));
            if (raterPosition != -1) {
                this.raters[raterPosition].RecordStatus = 2;
                //relationshipId = this.raters[raterPosition].RelationshipId;
                this.deletedRaters.push(this.raters[raterPosition]);
                this.raters.splice(raterPosition, 1);
            }
        } else {
            //in memory
            let raterPosition = this.raters.findIndex(x => x.tempIdCounter === raterId);
            if (raterPosition != -1) {
                //relationshipId = this.raters[raterPosition].RelationshipId;
                this.raters.splice(raterPosition, 1);
            }
        }
        console.log('deleted', this.deletedRaters);
        //button clicked
        if (e.target.nodeName == 'A') {
            e.target.parentElement.parentElement.remove();
        }

        //child element clicked
        if (e.target.nodeName == 'SPAN' || e.target.nodeName == 'I' ) {
            e.target.parentElement.parentElement.parentElement.remove();
        }

        //get the entries amount
        let entriesAmount = this.raters.filter((r) => {
            if (r.RelationshipId == relationshipId) return r;
        });
        //get the relationship min
        let relationship = this.raterTypes.filter((rt) => {
            if (relationshipId == rt.Id) return rt;
        });

        let inputEntries = $('#acc' + relationshipId + ' .categoryEntries .row');
        if (entriesAmount.length < relationship[0].Min && inputEntries.length < relationship[0].Min) {
            this.addNewRaterEntry(relationshipId);
        }

        //display min message if category doesnt have enought raters
        this.displayMinMessage(relationshipId);

        this.hideDeleteRatersConfirmationModal();
        this.inProgress = false;
    }

    editRaterEntry(e:any) {
        console.log('focusout event', e);
        
        let raterId = e.target.parentElement.parentElement.dataset.raterid;
        console.log('raterId', raterId);

        let regex = /tempId/;
        let result = regex.test(raterId);
        let relationshipId = parseInt(e.target.parentElement.parentElement.dataset.relationshipid);

        if (!result) {
            let raterPosition = this.raters.findIndex(x => x.RaterId === parseInt(raterId));
            if (raterPosition != -1) {
                if (e.target.name == 'Email') {
                    if (!this.validateEmail(e.target.value, raterPosition)) {
                        e.target.value = "";
                        //return;
                    }
                }
                this.raters[raterPosition].RecordStatus = 1;
                this.raters[raterPosition][e.target.name] = e.target.value;
                if (e.target.value != "") {
                    e.target.parentNode.parentElement.children[3].children[1].classList.value = "d-none d-sm-inline-block btn btn-sm btn-red deleteRaterEntry";
                } else {
                    let canDisable = true;
                    for (var i = 0; i < 3; i++) {
                        if (e.target.parentNode.parentElement.children[i].children[0].value != "") {
                            canDisable = false;
                        }
                    }
                    if (canDisable) {
                        this.raters.splice(raterPosition, 1);
                        //e.target.parentNode.parentElement.children[3].children[1].classList.value = "d-none d-sm-inline-block btn btn-sm btn-red deleteRaterEntry";
                    }
                }
            } else {
                let newRater = {
                    Email: "",
                    RaterId: 0,
                    FirstName: "",
                    LastName: "",
                    RelationshipId: relationshipId,
                    RecordStatus: 0,
                    tempIdCounter: 'tempId' + this.counter
                };
                this.raters.push(newRater);
                this.raters[this.raters.length - 1][e.target.name] = e.target.value;
                e.target.parentElement.parentElement.dataset.raterid = 'tempId' + this.counter;
                if (e.target.value != "") {
                    e.target.parentNode.parentElement.children[3].children[1].classList.value = "d-none d-sm-inline-block btn btn-sm btn-red deleteRaterEntry";
                } else {
                    let canDisable = true;
                    for (var i = 0; i < 3; i++) {
                        if (e.target.parentNode.parentElement.children[i].children[0].value != "") {
                            canDisable = false;
                        }
                    }
                    if (canDisable) {
                        this.raters.splice(this.raters.length, 1);
                        //e.target.parentNode.parentElement.children[3].children[1].classList.value = "d-none d-sm-inline-block btn btn-sm btn-red deleteRaterEntry";
                    }
                }
                this.counter++;
            }
        }
        else {
            //finding the position of the added memory entry tempIdCounter
            let raterPosition = this.raters.findIndex(
                x => x.tempIdCounter == raterId
            );
            if (raterPosition != -1) {
                if (e.target.name == 'Email') {
                    if (!this.validateEmail(e.target.value, raterPosition)) {
                        e.target.value = "";
                        //return;
                    }
                }
                this.raters[raterPosition][e.target.name] = e.target.value;
                if (e.target.value != "") {
                    e.target.parentNode.parentElement.children[3].children[1].classList.value = "d-none d-sm-inline-block btn btn-sm btn-red deleteRaterEntry";
                } else {
                    let canDisable = true;
                    for (var i = 0; i < 3; i++) {
                        if (e.target.parentNode.parentElement.children[i].children[0].value != "") {
                            canDisable = false;
                        }
                    }
                    if (canDisable) {
                        this.raters.splice(raterPosition, 1);
                        //e.target.parentNode.parentElement.children[3].children[1].classList.value = "d-none d-sm-inline-block btn btn-sm btn-red deleteRaterEntry";
                    } 
                }
                //EDITING A MEMORY ENTRY
            } else {
                //TOTALLY NEW ENTRY
                console.log('relationshipId', relationshipId);

                if (e.target.name == 'Email') {
                    if (!this.validateEmail(e.target.value, -1)) {
                        e.target.value = "";
                        //return;
                    }
                }

                let newRater = {
                    Email: "",
                    RaterId: 0,
                    FirstName: "",
                    LastName: "",
                    RelationshipId: relationshipId,
                    RecordStatus: 0,
                    tempIdCounter: raterId
                };
                this.raters.push(newRater);
                this.raters[this.raters.length - 1][e.target.name] = e.target.value;
                if (e.target.value != "") {
                    e.target.parentNode.parentElement.children[3].children[1].classList.value = "d-none d-sm-inline-block btn btn-sm btn-red deleteRaterEntry";
                } else {
                    let canDisable = true;
                    for (var i = 0; i < 3; i++) {
                        if (e.target.parentNode.parentElement.children[i].children[0].value != "") {
                            canDisable = false;
                        }
                    }
                    if (canDisable) {
                        this.raters.splice(this.raters.length - 1, 1);
                        //e.target.parentNode.parentElement.children[3].children[1].classList.value = "d-none d-sm-inline-block btn btn-sm btn-red deleteRaterEntry";
                    }
                }
            }
        }

        console.log('raters', this.raters);
        this.displayMinMessage(relationshipId);
        
    }
    
    changeRelationshipContent() {
        this.relationshipId = parseInt($('#relationships option:selected').val());
        this.categoryMin = parseInt($('#relationships option:selected').attr('id'));
    }

    createCategoryContent(id, min, lastId?: number) {
        let accOpen = $('.accOpen');
        let lastAcc;
        if (accOpen.length > 0) {
            lastAcc = accOpen[0].id;//.match(/\d/g).join(',');
            $("#acc" + id).insertBefore('#' + lastAcc);
        } else {
            $("#acc" + id).insertAfter('#forFirstelement');
        }
        //lastAcc = lastAcc.replace(",", "");

        //$("#acc" + id).insertAfter("#acc" + this.lastCategory);
        $('#acc' + id).css('display', 'block');
        $('#acc' + id).removeClass('accHide');
        $('#acc' + id).addClass('accOpen'); 
        //$('.acc div').removeClass('in');
        this.lastCategory = id;

        this.checkRatersAmount();
        if (id == lastId) {
            $('#acc' + id + ' .accDiv a').trigger('click');
            this.drawData(id, min);
            

            setTimeout(() => {
                let accOpen = $('.accOpen');
                console.log(accOpen);
                $('.accOpen')[0].children[0].children[0].children[0].children[1].classList.value = "fas fa-angle-up";
            //    var myElement = document.getElementById('acc' + id);
            //    var topPos = myElement.offsetTop;
            //    document.getElementById('mainAccordion').scrollTop = (topPos - 133); 
            },200);
        }
    }

    removeCatergoryContent() {
        console.log('removeCategoryContent');

        this.raters.filter((r) => { 
            if (this.bulkDeleteCategoryId === r.RelationshipId) {
                r.RecordStatus = 2;
                this.deletedRaters.push(r);
            };
        });

        console.log('deletedRaters', this.deletedRaters);

        this.raters = this.raters.filter((r) => {
            if (this.bulkDeleteCategoryId !== r.RelationshipId) return r;
        });
        console.log('raters', this.raters);

        $('#acc' + this.bulkDeleteCategoryId).css('display', 'None');
        $('#acc' + this.bulkDeleteCategoryId).removeClass('accOpen');
        $('#acc' + this.bulkDeleteCategoryId).addClass('accHide');
        $('.acc div').removeClass('in');  
        this.checkRatersAmount();
        this.hideBulkDeleteRatersConfirmationModal();
        this.inProgress = false;
    }
    
    openAddRelationshipsModal() {
        console.log('openAddRelationshipsModal');
        //this.getRaterTypesForCoach(true);  

        this.raterTypesStandartDataHeaders = this.createRaterTypesHeaders();
        this.raterTypesCustomDataHeaders = this.createRaterTypesHeaders();
        this.getGlobalRaterTypes();
        this.getRaterTypesByCoach();
        this.showRelationshipsModal();
    }

    showRelationshipsModal() {
        $('#addRelationshipsModal').modal('show');
        $('.add-rater-types-modal li').removeClass('active').eq(0).addClass('active');
    }

    hideRelationshipsModal() {
        $('.add-rater-types-modal li:first-child a').trigger('click');
        $('#addRelationshipsModal').modal('hide');
    }

    onRaterTypesStandartGridReady(params) {
        this.raterTypesStandartGridApi = params.api;
        setTimeout(() => {
            $(".ag-floating-filter-input").attr("placeholder", "Filter");
        }, 100);
    }

    onRaterTypesCustomGridReady(params) {
        this.raterTypesCustomGridApi = params.api;
        setTimeout(() => {
            $(".ag-floating-filter-input").attr("placeholder", "Filter");
        }, 100);
    }

    getRaterTypesByCoach() {
        this._CoachService.getRaterTypesByCoach().subscribe((data: any) => {
            console.log('response_GetRaterTypesByCoach', data);

            this.loading = false;
            if (this._Globals.validationToken(data.result.Result)) {
                this.raterTypesCustomData = JSON.parse(data.result.Data);
                console.log('data', this.raterTypesCustomData);
                
            }
        });
    }

    getGlobalRaterTypes() {
        this._AdminService.getGlobalRaterTypes().subscribe((data: any) => {
            console.log('response_GetGlobalRaterTypes', data);
            this.loading = false;

            if (this._Globals.validationToken(data.result.Result)) {
                this.raterTypesStandartData = JSON.parse(data.result.Data);
                console.log('data', this.raterTypesStandartData);

                setTimeout(() => {
                    this.sizeToFit(this.raterTypesStandartGridApi);
                }, 100);
            }
        });
    }

    createRaterTypesHeaders() {
        let columnDefs = new Array();

        let nameHeader = {
            headerName: 'Name',
            field: 'Name',
            minWidth: 200,
            width: 200,
            headerCheckboxSelection: true,
            headerCheckboxSelectionFilteredOnly: true,
            checkboxSelection: true,
            suppressSizeToFit: false,
            cellRenderer: function (params) {
                return params.value;
            }
        };
        columnDefs.push(nameHeader);

        return columnDefs;
    }

    onRaterTypesRowClicked(e) {
        console.log(e);
    }

    onRaterSelectionChanged(event) {
        console.log("onRaterSelectionChanged ", event);
        var rowCount = event.api.getSelectedNodes().length;
        console.log("selection changed, ", rowCount + " rows selected");
    }

    loadData(type: number) {
        switch (type) {
            case 1:
                console.log('1');
                this.isStandard = false;
                //this.getRaterTypesByCoach();
                setTimeout(() => {
                    this.sizeToFit(this.raterTypesCustomGridApi);
                }, 100);
                break;

            case 2:
                console.log('2');
                this.isStandard = true;
                //this.getGlobalRaterTypes();
                setTimeout(() => {
                    this.sizeToFit(this.raterTypesStandartGridApi);
                }, 100);
                break;
        }
    }

    /*ratersModal*/
    showRatersModal() {
        let selected = this.getSelectedRows(this.gridApi)
        this.ratersModal.show(selected[0].Id, selected[0].ClientId, 0, selected[0].ClientEmail);
    }

    //showEditClientModal
    showEditClientModal() {
        $('#editClientModal').modal('show');
    }

    hideEditClientModal() {
        $('#editClientModal').modal('hide');
    }

    //----QUICK MENU-----

    /*Purchase Modal*/
    openPurchaseModal() {
        //this._Globals.purchaseFromHome = true;
        this.purchaseAssessmentModal.show(this);
    }

    /*Assign Modal*/
    openAssignModal() {
        this.assignAssessmentModal.showAssignModal(this, 1);
    }

    /*CONVERTION RATE*/
    goToConversionRate() {
        if (this._Globals.assignedCanConversionRate) {
            let selected = this.getSelectedRows(this.gridApi)
            this._router.navigate(['/app/co_a_report', selected[0].Id, 'manage_clients', 0]);
        }
    }

/*ADD TAGS*/
    openAddTagsAssessmentsModal() {
        if (this.canAddTags) {
            console.log('openAddTagsAssessmentsModal');
            $("#editClientAddTagsModal").modal({ backdrop: "static" });
            $('#editClientAddTagsModal').modal('show');
        }
    }

    closeAddTagsModal() {
        $('#editClientAddTagsModal').modal('hide');
        this.assessmentAddTags = [];
        this.addTags = [];
    }

    addAssessmentsTags() {
        console.log('assessmentAddTags', this.assessmentAddTags);
        console.log('addTags', this.addTags);

        let selected = this.getSelectedRows(this.gridApi);

        console.log(selected);
        let assignmentIds = [];

        selected.forEach((item) => {
            assignmentIds.push(item.Id)
        });

        console.log('assignmentIds', assignmentIds);

        this._CoachService.postAddAssessmentsTags(assignmentIds, this.assessmentAddTags).subscribe((data: any) => {
            console.log("postAddAssessmentsTags_RESPONSE", data);
            if (this._Globals.validationToken(data.result.Result)) {
                console.log(data);
                this.closeAddTagsModal();

                switch (data.result.Result) {
                    case 0:
                        this._toastr.error('We are sorry. An error happened when trying to add the tags to the selected assignments', 'ELI');
                    break;

                    case 1:
                        this._toastr.success('Tags were successfully added to the selected assignments');
                        this.setAllInFalse();

                        switch (this.currentSelectedTab)
                        {
                            case 1: {
                                this.getClientAssignedAssessmentsByType(1);
                                break;
                            }

                            case 1.2: {
                                this.getClientAssignedAssessmentsByType(2);
                                break;
                            }

                            case 2: {
                                this.completedCanEnableResults = false;
                                this.completedCanArchiveAssessments = false;
                                this.getClientCompletedAssessmentsByType(1);
                                break;
                            }

                            case 2.2: {
                                this.getClientCompletedAssessmentsByType(2);
                                break;
                            }

                            case 3: {
                                this.getClientExpiredAssessmentsByType(1);
                                break;
                            }

                            case 3.2: {
                                this.getClientExpiredAssessmentsByType(2);
                                break;
                            }

                            case 4: {
                                this.getClientArchivedAssessments(1);
                                break;
                            }

                            case 4.2: {
                                this.getClientArchivedAssessments(2);
                                break;
                            }
                        }
                    break;
                }
            }
        });
    }

    onFocusInput() {
        console.log('onFocusInput');
        setTimeout(() => {
            $('.ng2-tag-input--focused').css('border-bottom', '2px solid skyblue');
        }, 100);
    }

    onItemAdded(e) {
        console.log("onItemAdded", e);

        this.assessmentAddTags.push(e.value);
        console.log(this.assessmentAddTags);
    }

    onItemRemoved(e) {
        console.log("onItemRemoved", e);

        const index = this.assessmentAddTags.indexOf(e.value);
        if (index !== -1) this.assessmentAddTags.splice(index, 1);
        console.log(this.assessmentAddTags);
    }

    /*Get Coach Tags*/
    openTagsModal() {
        $("#tagsModal").modal({ backdrop: "static" });
        $('#tagsModal').modal('show');
        this.coachTagsHeaders = this.createCoachTagsHeaders();
        this.getCoachTags();
        this.sizeToFit(this.coachTagsGridApi);
        setTimeout(() => {
            $(".ag-floating-filter-input").attr("placeholder", "Filter");
        }, 100);
    }

    createCoachTagsHeaders() {
        let columnDefs = new Array();

        let nameHeader = {
            headerName: 'Tag',
            field: 'Text',
            minWidth: 200,
            headerCheckboxSelection: true,
            headerCheckboxSelectionFilteredOnly: true,
            checkboxSelection: true,
            cellRenderer: function (params) {
                return params.value;
            }
        };
        columnDefs.push(nameHeader);


        return columnDefs;
    }

    onCoachTagsRowClicked(e) {
        console.log(e);
    }

    getCoachTags() {
        this._CoachService.getCoachTags().subscribe((data: any) => {
            console.log('getCoachTags data', data);
            if (this._Globals.validationToken(data.result.Result)) {
                let _data = JSON.parse(data.result.Data);
                console.log('response_GetCoachTags', _data);
                this.coachTags = _data;
            }
        });
    }

    onCoachTagsGridReady(params) {
        this.coachTagsGridApi = params.api;
        setTimeout(() => {
            $(".ag-floating-filter-input").attr("placeholder", "Filter");
        }, 100);
    }

    onCoachTagsSelectionChanged(event) {
        console.log("onCoachTagsSelectionChanged ", event);

        var rowCount = event.api.getSelectedNodes().length;
        console.log("selection changed, ", rowCount + " rows selected");

        this.selectedCoachTags = this.getSelectedRows(this.coachTagsGridApi);
        console.log("selectedCoachTags", this.selectedCoachTags);
    }

    addNewCoachTags() {

        this.selectedCoachTags.forEach((item) => {
            if (!this.addTags.find(x => x.value === item.Text)) {
                let tag = { display: item.Text, value: item.Text };
                this.addTags.push(tag);
                this.onItemAdded(tag); //add tags modal
            }
        });
        this.closeTagsModal();
    }

    closeTagsModal() {
        $('#tagsModal').modal('hide');
        this.selectedCoachTags = [];
    }

    openTab(menu: string) {
        var res = menu.split("-");
        console.log('currentSelectedTab', res[0]);
        console.log('tab', res[1]);

        //$(`.editClientTabs #tab1,
        //   .editClientTabs #tab2,
        //   .editClientTabs #tab3,
        //   .editClientTabs #tab4`).removeClass('active in');
        //$('.editClientTabs' + res[1]).addClass('active in');
        this.tabSelect(parseInt(res[0]));
    }

    focusTagsInput(id) {
        $('#' + id).focus();
    }

    getUserPersonalData() {
        $('body').css('cursor', 'wait');

        this._AdminService.getUserPersonalData(this._Globals.getUserId()).subscribe((data: any) => {
            console.log('response_getUserPersonalData', data);
            $('body').css('cursor', 'default');

            if (this._Globals.validationToken(data.result.Result)) {
                let _data = JSON.parse(data.result.Data);
                console.log('_data', _data);

                $("input[name='first_name']").val(_data.vg6);
                $("input[name='last_name']").val(_data.hj7);
                $("input[name='user_email']").val(_data.sr3);
                $("input[name='contact_id']").val(_data.by3);

                if (_data.by3 != "0") {
                    this.ssoToShopify();
                }
                else {
                    this._toastr.warning('You are not authorized to access the requested page', "ELI");
                }
            }
        })
    }

    ssoToShopify() {

        var shopifyForm: any = document.getElementById('shopifyForm');
        shopifyForm.submit();
    }
}


